(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1382],{

/***/ 46134:
/***/ (function(module) {

module.exports = "/_next/static/images/android-icon-192x192-f12285e5c892694a6c7c37beddabe3e3.png";

/***/ }),

/***/ 28386:
/***/ (function(module) {

module.exports = "/_next/static/images/apple-icon-114x114-ea98ee9aee9e939891dd546f60996891.png";

/***/ }),

/***/ 59625:
/***/ (function(module) {

module.exports = "/_next/static/images/apple-icon-120x120-317cc77e5c3635c5b7eb3185e6ee1c67.png";

/***/ }),

/***/ 69497:
/***/ (function(module) {

module.exports = "/_next/static/images/apple-icon-144x144-64a24269c6d6ca0674cb323add7fc784.png";

/***/ }),

/***/ 20740:
/***/ (function(module) {

module.exports = "/_next/static/images/apple-icon-152x152-6d742e7d1a2c60360cd529cbc1544502.png";

/***/ }),

/***/ 60602:
/***/ (function(module) {

module.exports = "/_next/static/images/apple-icon-57x57-8003cf9cc0e66cd25716f12d663538a3.png";

/***/ }),

/***/ 95800:
/***/ (function(module) {

module.exports = "/_next/static/images/apple-icon-60x60-3e4f29cff5c62c27e0faefcf09c0e9d0.png";

/***/ }),

/***/ 43195:
/***/ (function(module) {

module.exports = "/_next/static/images/apple-icon-72x72-56412c22acaed638c44e5a71500031db.png";

/***/ }),

/***/ 63239:
/***/ (function(module) {

module.exports = "/_next/static/images/apple-icon-76x76-88664c0df39785b5dda834815933e1f5.png";

/***/ }),

/***/ 56490:
/***/ (function(module) {

module.exports = "/_next/static/images/favicon-16x16-1b667093097f2c2dc0111644520b6658.png";

/***/ }),

/***/ 78643:
/***/ (function(module) {

module.exports = "/_next/static/images/favicon-32x32-ec2c76c8b1104a54d07e28122a83dee9.png";

/***/ }),

/***/ 27468:
/***/ (function(module) {

module.exports = "/_next/static/images/favicon-96x96-21a939b7ca020e126d00d9c0a1d22112.png";

/***/ }),

/***/ 71899:
/***/ (function(module) {

module.exports = "/_next/static/images/ms-icon-144x144-600ec7d419289241e69d3a2b1a84de44.png";

/***/ }),

/***/ 79654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _useDesignTokens__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98439);
/* harmony import */ var _ButtonText_views__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54351);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52903);


var _excluded = ["size", "className", "children", "tag", "onClick", "onKeyDown", "role", "id", "iconStart", "iconEnd", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size,
      className = _ref.className,
      children = _ref.children,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? "button" : _ref$tag,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      role = _ref.role,
      id = _ref.id,
      IconStart = _ref.iconStart,
      IconEnd = _ref.iconEnd,
      tokens = _ref.tokens,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_ButtonText_views__WEBPACK_IMPORTED_MODULE_3__/* .ButtonText */ .o, _objectSpread(_objectSpread(_objectSpread({
    tag: rest.href ? "a" : tag,
    ref: ref,
    className: className,
    onClick: onClick,
    onKeyDown: onKeyDown,
    role: role,
    id: id
  }, tokens), rest), {}, {
    variant: size === "medium" ? "buttonTextMedium" : "buttonTextSmall",
    children: [IconStart ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(IconStart, {
      size: size
    }) : null, children, IconEnd ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(IconEnd, {
      size: size
    }) : null]
  }));
});
var ButtonText = (0,_useDesignTokens__WEBPACK_IMPORTED_MODULE_2__/* .withDesignTokens */ .Y)(BaseButtonText, function (_ref2) {
  var color = _ref2.color,
      size = _ref2.size,
      hover = _ref2.hover,
      iconStart = _ref2.iconStart,
      iconEnd = _ref2.iconEnd;
  return {
    color: color,
    width: iconStart || iconEnd ? "calc(100% - ".concat(size === "small" ? 5 : 7, "px)") : "100%",
    iconStart: Boolean(iconStart),
    hover: hover
  };
}, {
  light: function light(theme, _ref3) {
    var variant = _ref3.variant,
        color = _ref3.color;

    if (color) {
      return {
        textColor: color,
        hoverColor: color
      };
    }

    switch (variant) {
      case "mono":
        return {
          textColor: theme.palette.neutrals.black[100],
          hoverColor: theme.palette.neutrals.black[100]
        };

      case "brand":
      default:
        return {
          textColor: theme.palette.brand.boysenberry[500],
          hoverColor: theme.palette.brand.boysenberry[500]
        };
    }
  },
  dark: function dark(theme, _ref4) {
    var color = _ref4.color,
        variant = _ref4.variant;

    if (color) {
      return {
        textColor: color,
        hoverColor: color
      };
    }

    switch (variant) {
      case "mono":
        return {
          textColor: theme.palette.neutrals.white[100],
          hoverColor: theme.palette.neutrals.white[100]
        };

      case "brand":
      default:
        return {
          textColor: theme.palette.brand.segmentGreen[500],
          hoverColor: theme.palette.brand.segmentGreen[500]
        };
    }
  },
  twilioLight: function twilioLight(theme, _ref5) {
    var color = _ref5.color,
        _ref5$variant = _ref5.variant,
        variant = _ref5$variant === void 0 ? "primary" : _ref5$variant;

    if (color) {
      return {
        textColor: color,
        hoverColor: color
      };
    }

    switch (variant) {
      case "secondary":
        return {
          textColor: theme.palette.twilio.gray[100],
          hoverColor: theme.palette.twilio.gray[100]
        };

      case "mono":
        return {
          textColor: theme.palette.twilio.gray[100],
          hoverColor: theme.palette.twilio.gray[100]
        };

      case "primary":
      default:
        return {
          textColor: theme.palette.twilio.blue[60],
          hoverColor: theme.palette.twilio.blue[70]
        };
    }
  },
  twilioDark: function twilioDark(theme, _ref6) {
    var color = _ref6.color,
        _ref6$variant = _ref6.variant,
        variant = _ref6$variant === void 0 ? "primary" : _ref6$variant;

    if (color) {
      return {
        textColor: color,
        hoverColor: color
      };
    }

    switch (variant) {
      case "secondary":
        return {
          textColor: theme.palette.twilio.gray[100],
          hoverColor: theme.palette.twilio.gray[100]
        };

      case "mono":
        return {
          textColor: theme.palette.twilio.gray[100],
          hoverColor: theme.palette.twilio.gray[100]
        };

      case "primary":
      default:
        return {
          textColor: theme.palette.neutrals.white[100],
          hoverColor: theme.palette.neutrals.white[100]
        };
    }
  },
  cdpWeek2023: function cdpWeek2023(theme, _ref7) {
    var color = _ref7.color,
        _ref7$variant = _ref7.variant,
        variant = _ref7$variant === void 0 ? "primary" : _ref7$variant;

    if (color) {
      return {
        textColor: color,
        hoverColor: color
      };
    }

    switch (variant) {
      case "secondary":
        return {
          textColor: theme.palette.cdpWeek2023.blue[40],
          hoverColor: theme.palette.cdpWeek2023.blue[40]
        };

      case "mono":
        return {
          textColor: theme.palette.neutrals.white[100],
          hoverColor: theme.palette.neutrals.white[100]
        };

      case "primary":
      default:
        return {
          textColor: theme.palette.cdpWeek2023.blue[40],
          hoverColor: theme.palette.cdpWeek2023.blue[40]
        };
    }
  }
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ButtonText)));

/***/ }),

/***/ 54351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ hoverStyles; },
/* harmony export */   "o": function() { return /* binding */ ButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7328);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28165);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89533);



var _templateObject;

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var hoverStyles =  true ? {
  name: "1yx7idh",
  styles: "::after{transform:scaleX(1);transform-origin:left;}"
} : 0;
var activeKeyframes = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_templateObject || (_templateObject = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  0% {\n    opacity: 1;\n  }\n  30% {\n    opacity: 0.1;\n  }\n  100% {\n    opacity: 0.6;\n  }\n"])));

var _ref =  true ? {
  name: "1ode3cm",
  styles: "left:0"
} : 0;

var _ref2 =  true ? {
  name: "1wf8jf",
  styles: "right:0"
} : 0;

var ButtonText = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_Typography__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,  true ? {
  target: "e1t2053s0"
} : 0)("--button-text-transition:0.6s 0.1s cubic-bezier(0.25, 1, 0.5, 1);position:relative;cursor:pointer;display:inline-grid;grid-auto-flow:column;grid-gap:4px;align-items:center;justify-content:center;vertical-align:middle;margin:0;padding:6px 0;text-decoration:none;transition:color var(--button-text-transition);direction:ltr;color:", function (_ref3) {
  var textColor = _ref3.textColor;
  return textColor;
}, ";::after{position:absolute;bottom:0;height:2px;background:currentColor;width:", function (_ref4) {
  var width = _ref4.width;
  return width;
}, ";transform:scaleX(0);transition:transform var(--button-text-transition);transform-origin:right;opacity:1;content:'';", function (_ref5) {
  var iconStart = _ref5.iconStart;
  return iconStart && _ref2;
}, " ", function (_ref6) {
  var iconStart = _ref6.iconStart;
  return !iconStart && _ref;
}, ";}", function (_ref7) {
  var hover = _ref7.hover;
  return hover && hoverStyles;
}, " :hover,:focus-visible{", hoverStyles, " color:", function (_ref8) {
  var hoverColor = _ref8.hoverColor;
  return hoverColor;
}, ";}:active{animation:0.5s ", activeKeyframes, " 0s ease-in-out forwards;}:disabled{opacity:0.4;pointer-events:none;}" + ( true ? "" : 0));

/***/ }),

/***/ 74870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _ButtonText__WEBPACK_IMPORTED_MODULE_0__.o; }
/* harmony export */ });
/* harmony import */ var _ButtonText__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79654);


/***/ }),

/***/ 89799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Divider; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);

var Divider = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("hr",  true ? {
  target: "e7tzie10"
} : 0)("background-color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";width:100%;border:0;height:", function (_ref2) {
  var size = _ref2.size;
  return size === "small" ? "1px" : "4px";
}, ";margin:5px 0;" + ( true ? "" : 0));

/***/ }),

/***/ 76305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Divider_Divider; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/Divider.views.tsx
var Divider_views = __webpack_require__(89799);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Divider/Divider.tsx


var _excluded = ["tokens", "size", "className"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseDivider = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "small" : _ref$size,
      className = _ref.className,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider_views/* Divider */.i, _objectSpread(_objectSpread({
    ref: ref
  }, tokens), {}, {
    size: size,
    className: className
  }, rest));
});
var Divider = (0,useDesignTokens/* withDesignTokens */.Y)(BaseDivider, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.boysenberry[200]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[20]
    };
  }
});
/* harmony default export */ var Divider_Divider = (Divider);
;// CONCATENATED MODULE: ../../libs/matcha/components/Divider/index.ts


/***/ }),

/***/ 33606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Elevation; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js
var emotion_is_prop_valid_esm = __webpack_require__(86015);
;// CONCATENATED MODULE: ../../libs/matcha/components/Elevation/Elevation.views.tsx




var boxShadowToDropShadow = function boxShadowToDropShadow(boxShadow) {
  var regex = /(-?\d+px)/g;
  var matches = boxShadow.match(regex);

  if ((matches === null || matches === void 0 ? void 0 : matches.length) === 4) {
    var spread = matches.pop();
    var splitValues = boxShadow.split(spread);
    return "".concat(matches.join(" "), " ").concat(splitValues[1].trim());
  }

  return boxShadow;
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return (0,emotion_is_prop_valid_esm/* default */.Z)(prop) && prop !== "elevation";
  },
  target: "e91xqsx0"
} : 0)(function (_ref) {
  var type = _ref.type,
      elevation = _ref.elevation,
      theme = _ref.theme;

  switch (type) {
    case "boxShadow":
      return (
        /*#__PURE__*/

        /*#__PURE__*/
        (0,emotion_react_browser_esm/* css */.iv)("box-shadow:", theme.shadows[elevation], ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
      );

    case "dropShadow":
      return (
        /*#__PURE__*/

        /*#__PURE__*/
        (0,emotion_react_browser_esm/* css */.iv)("filter:drop-shadow(", boxShadowToDropShadow(theme.shadows[elevation]), ");" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
      );

    default:
  }
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Elevation/Elevation.tsx


var _excluded = ["elevation", "type", "tag", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Elevation = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var elevation = _ref.elevation,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "boxShadow" : _ref$type,
      tag = _ref.tag,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, _objectSpread(_objectSpread({
    ref: ref,
    type: type,
    as: tag,
    elevation: elevation
  }, rest), {}, {
    children: children
  }));
});
;// CONCATENATED MODULE: ../../libs/matcha/components/Elevation/index.ts


/***/ }),

/***/ 6580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xd": function() { return /* reexport */ Common_ArrowLeft; },
  "ol": function() { return /* reexport */ Common_ArrowRight; },
  "nQ": function() { return /* reexport */ Common_CheckIcon; },
  "v4": function() { return /* reexport */ Common_ChevronDownIcon; },
  "wy": function() { return /* reexport */ Common_ChevronLeftIcon; },
  "XC": function() { return /* reexport */ Common_ChevronRightIcon; },
  "g8": function() { return /* reexport */ Common_ChevronUpIcon; },
  "Rk": function() { return /* reexport */ Common_ClearIcon; },
  "Tw": function() { return /* reexport */ Common_CloseIcon; },
  "Pz": function() { return /* reexport */ Common_ErrorIcon; },
  "sz": function() { return /* reexport */ Common_InfoIcon; },
  "Oq": function() { return /* reexport */ Common_MenuIcon; }
});

// UNUSED EXPORTS: ArrowUpRight, UpdatesIcon

// EXTERNAL MODULE: ../../libs/matcha/components/Icons/utils/createIconsComponent.tsx + 1 modules
var createIconsComponent = __webpack_require__(37699);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Common/ArrowLeft.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var ArrowLeft = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.27287 12.6866L8.76721 19.6805C9.14301 20.0852 9.77575 20.1086 10.1805 19.7328C10.5852 19.357 10.6086 18.7243 10.2328 18.3196L5.29322 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H5.29321L10.2328 5.68046C10.6086 5.27574 10.5852 4.64301 10.1805 4.26721C9.77575 3.89141 9.14301 3.91484 8.76721 4.31955L2.26896 11.3177C2.10211 11.4964 2 11.7363 2 12C2 12.1448 2.03079 12.2825 2.08619 12.4068C2.13104 12.5077 2.19333 12.6025 2.27287 12.6866Z",
    fill: "none"
  })
}), 'ArrowLeft', 'Common');
/* harmony default export */ var Common_ArrowLeft = (ArrowLeft);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Common/ArrowRight.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var ArrowRight = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7271 12.6866L15.2328 19.6805C14.857 20.0852 14.2243 20.1086 13.8195 19.7328C13.4148 19.357 13.3914 18.7243 13.7672 18.3196L18.7068 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H18.7068L13.7672 5.68046C13.3914 5.27574 13.4148 4.64301 13.8195 4.26721C14.2243 3.89141 14.857 3.91484 15.2328 4.31955L21.731 11.3177C21.8979 11.4964 22 11.7363 22 12C22 12.1448 21.9692 12.2825 21.9138 12.4068C21.869 12.5077 21.8067 12.6025 21.7271 12.6866Z",
    fill: "none"
  })
}), 'ArrowRight', 'Common');
/* harmony default export */ var Common_ArrowRight = (ArrowRight);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Common/ArrowUpRight.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var ArrowUpRight = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M19.205 12.519a.75.75 0 0 0 1.5.023l.126-8.146a1.194 1.194 0 0 0-.346-.881 1.182 1.182 0 0 0-.881-.346l-8.146.126a.75.75 0 1 0 .023 1.5l6.768-.105L3.515 19.425a.75.75 0 0 0 1.06 1.06L19.31 5.751l-.105 6.768Z"
  })
}), 'ArrowUpRight', 'Common');
/* harmony default export */ var Common_ArrowUpRight = ((/* unused pure expression or super */ null && (ArrowUpRight)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Common/CheckIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var CheckIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4962 6.32452C19.0902 6.81951 19.1705 7.7023 18.6755 8.29629L11.6755 16.6963C11.4237 16.9984 11.0564 17.1807 10.6634 17.1986C10.2705 17.2164 9.8882 17.0681 9.61 16.79L5.41005 12.59C4.86332 12.0432 4.86332 11.1568 5.41005 10.6101C5.95678 10.0633 6.84321 10.0633 7.38994 10.6101L10.5059 13.726L16.5245 6.50378C17.0195 5.90979 17.9022 5.82954 18.4962 6.32452Z"
  })
}), 'CheckIcon', 'Common');
/* harmony default export */ var Common_CheckIcon = (CheckIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Common/ChevronDownIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var ChevronDownIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M11.3625 16.1418L6.3625 11.1388C6.1375 10.9136 6 10.601 6 10.2507C6 9.56284 6.5625 9 7.25 9C7.6 9 7.9125 9.13758 8.1375 9.36272L12.25 13.4902L16.3625 9.37522C16.5875 9.13758 16.9 9 17.25 9C17.9375 9 18.5 9.56284 18.5 10.2507C18.5 10.601 18.3625 10.9136 18.1375 11.1388L13.1375 16.1418C12.9125 16.3669 12.6 16.5045 12.25 16.5045C11.9 16.5045 11.5875 16.3669 11.3625 16.1418Z",
    fill: "none"
  })
}), 'ChevronDownIcon', 'Common');
/* harmony default export */ var Common_ChevronDownIcon = (ChevronDownIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Common/ChevronLeftIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var ChevronLeftIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M7.94394 11.1125L12.9469 6.1125C13.1721 5.8875 13.4847 5.75 13.8349 5.75C14.5229 5.75 15.0857 6.3125 15.0857 7C15.0857 7.35 14.9481 7.6625 14.723 7.8875L10.5955 12L14.7105 16.1125C14.9481 16.3375 15.0857 16.65 15.0857 17C15.0857 17.6875 14.5229 18.25 13.8349 18.25C13.4847 18.25 13.1721 18.1125 12.9469 17.8875L7.94394 12.8875C7.71881 12.6625 7.58123 12.35 7.58123 12C7.58123 11.65 7.71881 11.3375 7.94394 11.1125Z",
    fill: "none"
  })
}), 'ChevronLeftIcon', 'Common');
/* harmony default export */ var Common_ChevronLeftIcon = (ChevronLeftIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Common/ChevronRightIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var ChevronRightIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M16.2274 11.1125L11.2245 6.1125C10.9993 5.8875 10.6866 5.75 10.3364 5.75C9.64853 5.75 9.08569 6.3125 9.08569 7C9.08569 7.35 9.22328 7.6625 9.44841 7.8875L13.5759 12L9.46092 16.1125C9.22328 16.3375 9.08569 16.65 9.08569 17C9.08569 17.6875 9.64853 18.25 10.3364 18.25C10.6866 18.25 10.9993 18.1125 11.2245 17.8875L16.2274 12.8875C16.4526 12.6625 16.5902 12.35 16.5902 12C16.5902 11.65 16.4526 11.3375 16.2274 11.1125Z",
    fill: "none"
  })
}), 'ChevronRightIcon', 'Common');
/* harmony default export */ var Common_ChevronRightIcon = (ChevronRightIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Common/ChevronUpIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var ChevronUpIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M11.3625 7.8582L6.3625 12.8612C6.1375 13.0863 6 13.399 6 13.7492C6 14.4371 6.5625 15 7.25 15C7.6 15 7.9125 14.8624 8.1375 14.6372L12.25 10.5098L16.3625 14.6247C16.5875 14.8624 16.9 15 17.25 15C17.9375 15 18.5 14.4371 18.5 13.7492C18.5 13.399 18.3625 13.0863 18.1375 12.8612L13.1375 7.8582C12.9125 7.63307 12.6 7.49548 12.25 7.49548C11.9 7.49548 11.5875 7.63307 11.3625 7.8582Z",
    fill: "none"
  })
}), 'ChevronUpIcon', 'Common');
/* harmony default export */ var Common_ChevronUpIcon = (ChevronUpIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Common/ClearIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var ClearIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M17.04 8.707a1 1 0 00-1.414-1.414l-3.293 3.293L9.04 7.293a1 1 0 00-1.414 1.414L10.92 12l-3.293 3.293a1 1 0 101.414 1.414l3.293-3.293 3.293 3.293a1 1 0 001.414-1.414L13.748 12l3.292-3.293z"
  })
}), 'ClearIcon', 'Common');
/* harmony default export */ var Common_ClearIcon = (ClearIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Common/CloseIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var CloseIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fill: "none",
    d: "M4.293 19.705a1 1 0 0 1 0-1.414L18.29 4.293a1 1 0 1 1 1.414 1.414L5.707 19.705a1 1 0 0 1-1.414 0Z"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fill: "none",
    d: "M19.705 19.705a1 1 0 0 0 0-1.414L5.707 4.293a1 1 0 0 0-1.414 1.414l13.998 13.998a1 1 0 0 0 1.414 0Z"
  })]
}), 'CloseIcon', 'Common');
/* harmony default export */ var Common_CloseIcon = (CloseIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Common/ErrorIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var ErrorIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM10.8388 7.54547H13.1609L12.9485 14.1055H11.0512L10.8388 7.54547ZM13.2024 15.9336C13.1932 16.5984 12.6346 17.1339 12.0022 17.1339C11.3374 17.1339 10.7926 16.5984 10.8019 15.9336C10.7926 15.2781 11.3374 14.7472 12.0022 14.7472C12.6346 14.7472 13.1932 15.2781 13.2024 15.9336Z"
  })
}), 'ErrorIcon', 'Common');
/* harmony default export */ var Common_ErrorIcon = (ErrorIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Common/InfoIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var InfoIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    d: "M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Zm1 3v2h-2V7h2Zm-3 9v1h4v-1h-1v-6h-3v1h1v5h-1Z",
    clipRule: "evenodd"
  })
}), 'InfoIcon', 'Common');
/* harmony default export */ var Common_InfoIcon = (InfoIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Common/MenuIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var MenuIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M2 5C2 4.44772 2.44772 4 3 4H21C21.5523 4 22 4.44772 22 5C22 5.55228 21.5523 6 21 6H3C2.44772 6 2 5.55228 2 5Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M2 12C2 11.4477 2.44772 11 3 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M3 18C2.44772 18 2 18.4477 2 19C2 19.5523 2.44772 20 3 20H21C21.5523 20 22 19.5523 22 19C22 18.4477 21.5523 18 21 18H3Z",
    fill: "none"
  })]
}), 'MenuIcon', 'Common');
/* harmony default export */ var Common_MenuIcon = (MenuIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Common/UpdatesIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var UpdatesIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M5.1289 19.1219C6.30221 17.9497 6.30221 16.0494 5.1289 14.8773C3.95559 13.7051 2.05329 13.7051 0.87998 14.8773C-0.293327 16.0494 -0.293327 17.9497 0.87998 19.1219C2.05329 20.294 3.95559 20.294 5.1289 19.1219Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M3.00444 6.9823C2.47105 6.9823 1.95951 7.19397 1.58234 7.57076C1.20518 7.94754 0.993286 8.45856 0.993286 8.99142C0.993286 9.52427 1.20518 10.0353 1.58234 10.4121C1.95951 10.7889 2.47105 11.0005 3.00444 11.0005C4.5968 11.0015 6.12365 11.6339 7.24962 12.7587C8.37559 13.8835 9.00859 15.4088 9.00958 16.9996C9.01115 17.5282 9.22206 18.0347 9.59622 18.4085C9.97039 18.7823 10.4774 18.993 11.0066 18.9945C11.271 18.9956 11.533 18.9444 11.7775 18.8438C12.022 18.7432 12.2441 18.5953 12.4311 18.4085C12.6181 18.2217 12.7662 17.9998 12.8668 17.7556C12.9675 17.5113 13.0188 17.2496 13.0177 16.9854C13.0173 14.3326 11.9622 11.7885 10.0845 9.91259C8.20669 8.03673 5.66001 6.9827 3.00444 6.9823Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M3.00436 0.0210874C2.72028 -0.0194549 2.43079 0.00145698 2.1555 0.0824095C1.88021 0.163362 1.62555 0.302464 1.40876 0.490296C1.19197 0.678127 1.01811 0.910303 0.898956 1.1711C0.779804 1.4319 0.71814 1.71523 0.71814 2.00191C0.71814 2.28858 0.779802 2.57191 0.898954 2.83271C1.01811 3.09351 1.19197 3.32568 1.40876 3.51351C1.62555 3.70134 1.88021 3.84045 2.1555 3.9214C2.43079 4.00235 2.72028 4.02326 3.00436 3.98272C6.45448 3.98891 9.76152 5.36081 12.2011 7.79794C14.6407 10.2351 16.014 13.5388 16.0202 16.9854C16.0191 17.2495 16.0704 17.5113 16.1711 17.7555C16.2718 17.9998 16.4199 18.2217 16.6069 18.4085C16.7938 18.5952 17.016 18.7432 17.2605 18.8438C17.5049 18.9443 17.767 18.9956 18.0314 18.9945C18.5556 18.9855 19.0554 18.7716 19.4235 18.3986C19.7915 18.0256 19.9986 17.5233 20 16.9995C19.9922 12.499 18.1991 8.18495 15.0135 5.00256C11.8279 1.82017 7.5095 0.0288738 3.00436 0.0210874Z",
    fill: "none"
  })]
}), 'UpdatesIcon', 'Common');
/* harmony default export */ var Common_UpdatesIcon = ((/* unused pure expression or super */ null && (UpdatesIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/Common.ts
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */















/***/ }),

/***/ 37699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_createIconsComponent; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/wrappers/IconWrapper.tsx
var IconWrapper = __webpack_require__(59844);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/wrappers/SegmentIconsWrapper.tsx


var _excluded = ["children", "size"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var SegmentIconsWrapper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper/* default */.Z, _objectSpread(_objectSpread({
    ref: ref,
    size: size
  }, rest), {}, {
    children: children
  }));
});
/* harmony default export */ var wrappers_SegmentIconsWrapper = (SegmentIconsWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/utils/createIconsComponent.tsx


var createIconsComponent_excluded = ["children"];

function createIconsComponent_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function createIconsComponent_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? createIconsComponent_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : createIconsComponent_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var createIconsComponent = function createIconsComponent(path, displayName, type) {
  var Wrapper = type === "Segment" ? wrappers_SegmentIconsWrapper : IconWrapper/* default */.Z;

  var Component = function Component(_ref, ref) {
    var children = _ref.children,
        rest = (0,objectWithoutProperties/* default */.Z)(_ref, createIconsComponent_excluded);

    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, createIconsComponent_objectSpread(createIconsComponent_objectSpread({
      ref: ref,
      "data-testid": "icon[".concat(displayName, "]")
    }, rest), {}, {
      children: [path, children]
    }));
  };

  if (false) {}

  return /*#__PURE__*/(0,react.memo)( /*#__PURE__*/(0,react.forwardRef)(Component));
};

/* harmony default export */ var utils_createIconsComponent = (createIconsComponent);

/***/ }),

/***/ 59844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Wrapper; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82269);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52903);



var _excluded = ["children", "color", "size", "label"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var SIZES = {
  small: 16,
  medium: 24,
  large: 32,
  nav: 20
};
var IconWrapper = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      color = _ref.color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size,
      label = _ref.label,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return label ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Wrapper, _objectSpread(_objectSpread({
    fillColor: color,
    size: size,
    ref: ref,
    "aria-label": label,
    role: "img"
  }, rest), {}, {
    children: children
  })) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Wrapper, _objectSpread(_objectSpread({
    fillColor: color,
    size: size,
    ref: ref,
    "aria-hidden": "true"
  }, rest), {}, {
    children: children
  }));
});
var Wrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e1m0cbuf0"
} : 0)("display:inline-block;justify-self:center;svg{display:block;width:", function (_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? "medium" : _ref2$size;
  return SIZES[size];
}, "px;height:", function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? "medium" : _ref3$size;
  return SIZES[size];
}, "px;path[fill='none'],path:not([fill]){fill:", function (_ref4) {
  var fillColor = _ref4.fillColor;
  return fillColor ? fillColor : "currentColor";
}, ";}}" + ( true ? "" : 0));
/* harmony default export */ __webpack_exports__["Z"] = (IconWrapper);

/***/ }),

/***/ 75091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Media; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/matcha/components/Media/Media.views.tsx



var isNumeric = function isNumeric(value) {
  return typeof value === "number";
};
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eiase400"
} : 0)("width:inherit;", function (_ref) {
  var theme = _ref.theme,
      at = _ref.at;
  return at &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("display:none;", theme.breakpoints.only(at), "{display:unset;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref2) {
  var theme = _ref2.theme,
      breakpointsKeys = _ref2.breakpointsKeys,
      lessThan = _ref2.lessThan;
  return lessThan &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("display:none;", theme.breakpoints.down(isNumeric(lessThan) ? lessThan : breakpointsKeys[breakpointsKeys.indexOf(lessThan) - 1]), "{display:unset;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref3) {
  var theme = _ref3.theme,
      breakpointsKeys = _ref3.breakpointsKeys,
      greaterThan = _ref3.greaterThan;
  return greaterThan &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("display:none;", theme.breakpoints.up(isNumeric(greaterThan) ? greaterThan : breakpointsKeys[breakpointsKeys.indexOf(greaterThan) + 1]), "{display:unset;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref4) {
  var theme = _ref4.theme,
      greaterThanOrEqual = _ref4.greaterThanOrEqual;
  return greaterThanOrEqual &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("display:none;", theme.breakpoints.up(greaterThanOrEqual), "{display:unset;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref5) {
  var _theme$breakpoints;

  var theme = _ref5.theme,
      between = _ref5.between;
  return between &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("display:none;", (_theme$breakpoints = theme.breakpoints).between.apply(_theme$breakpoints, (0,toConsumableArray/* default */.Z)(between)), "{display:unset;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Media/Media.tsx






var Media = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var at = _ref.at,
      lessThan = _ref.lessThan,
      greaterThan = _ref.greaterThan,
      greaterThanOrEqual = _ref.greaterThanOrEqual,
      between = _ref.between,
      children = _ref.children;

  var _useTheme = (0,emotion_element_6a883da9_browser_esm.u)(),
      breakpoints = _useTheme.breakpoints;

  var breakpointsKeys = Object.keys(breakpoints.values);

  if (greaterThan === breakpointsKeys[breakpointsKeys.length - 1]) {
    throw new Error("There is no breakpoint larger than ".concat(greaterThan));
  }

  var queries = (0,react.useMemo)(function () {
    return {
      at: at ? breakpoints.between(at, isNumeric(at) ? at : breakpointsKeys[breakpointsKeys.indexOf(at)], false) : "",
      lessThan: lessThan ? breakpoints.down(lessThan, false) : "",
      greaterThan: greaterThan ? breakpoints.up(isNumeric(greaterThan) ? greaterThan : breakpointsKeys[breakpointsKeys.indexOf(greaterThan) + 1], false) : "",
      greaterThanOrEqual: greaterThanOrEqual ? breakpoints.up(greaterThanOrEqual, false) : "",
      between: between ? breakpoints.between.apply(breakpoints, (0,toConsumableArray/* default */.Z)(between).concat([false])) : ""
    };
  }, [at, between, breakpoints, breakpointsKeys, greaterThan, greaterThanOrEqual, lessThan]);
  var isAtResolution = (0,useMatchMedia/* default */.Z)(queries.at, true);
  var isLessThanResolution = (0,useMatchMedia/* default */.Z)(queries.lessThan, true);
  var isGreaterThanResolution = (0,useMatchMedia/* default */.Z)(queries.greaterThan, true);
  var isGreaterThanOrEqualResolution = (0,useMatchMedia/* default */.Z)(queries.greaterThanOrEqual, true);
  var isBetweenResolution = (0,useMatchMedia/* default */.Z)(queries.between, true);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    at: at,
    lessThan: lessThan,
    greaterThan: greaterThan,
    greaterThanOrEqual: greaterThanOrEqual,
    between: between,
    breakpointsKeys: breakpointsKeys,
    "data-testid": "media-wrapper",
    children: (isAtResolution || isLessThanResolution || isGreaterThanResolution || isGreaterThanOrEqualResolution || isBetweenResolution) && children
  });
});
;// CONCATENATED MODULE: ../../libs/matcha/components/Media/index.ts


/***/ }),

/***/ 28536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* reexport */ MenuListItem_MenuListItem; },
  "Z": function() { return /* reexport */ MenuList_MenuList; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/useEventCallback/index.ts
var useEventCallback = __webpack_require__(93026);
;// CONCATENATED MODULE: ../../libs/matcha/components/MenuList/MenuListContext.ts

var MenuListContext = /*#__PURE__*/(0,react.createContext)(null);
var MenuListStateProvider = MenuListContext.Provider;
var useMenuListState = function useMenuListState() {
  var context = (0,react.useContext)(MenuListContext);

  if (!context) {
    throw new Error("MenuListContext isn't available. Please set it via MenuListContextProvider component.");
  }

  return context;
};
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/components/MenuList/MenuList.views.ts

var MenuList = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e3k8rwm0"
} : 0)("padding:0;background-color:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/MenuList/MenuList.tsx


var _excluded = ["role", "tabIndex", "children", "interactive", "onItemClick", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var BaseMenuList = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var role = _ref.role,
      tabIndex = _ref.tabIndex,
      children = _ref.children,
      interactive = _ref.interactive,
      onItemClick = _ref.onItemClick,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var onClickHandler = (0,useEventCallback/* default */.Z)(onItemClick, []);
  var state = (0,react.useMemo)(function () {
    return {
      interactive: interactive,
      onClick: onClickHandler
    };
  }, [interactive, onClickHandler]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuListStateProvider, {
    value: state,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuList, _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      role: role,
      tabIndex: tabIndex
    }, rest), tokens), {}, {
      children: children
    }))
  });
});
var MenuList_MenuList = (0,useDesignTokens/* withDesignTokens */.Y)(BaseMenuList, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[600]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100]
    };
  }
});
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(13102);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/matcha/components/MenuList/MenuListItem.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var _ref =  true ? {
  name: "o4i91h",
  styles: "display:grid;justify-content:space-between;grid-template-columns:auto auto;gap:15px;align-items:center"
} : 0;

var MenuListItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "e1ahw00v0"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.formInput;
}, ";color:", function (_ref3) {
  var color = _ref3.color;
  return color;
}, ";padding:14px 16px;list-style-type:none;:focus{outline:none;}", function (_ref4) {
  var hasSelectedIcon = _ref4.hasSelectedIcon;
  return hasSelectedIcon && _ref;
}, " ", function (_ref5) {
  var interactive = _ref5.interactive,
      activeBackgroundColor = _ref5.activeBackgroundColor;
  return interactive &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("cursor:pointer;:active{background-color:", activeBackgroundColor, ";}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref6) {
  var interactive = _ref6.interactive,
      focused = _ref6.focused,
      focusBackgroundColor = _ref6.focusBackgroundColor;
  return interactive && focused &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("background-color:", focusBackgroundColor, ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref7) {
  var interactive = _ref7.interactive,
      selected = _ref7.selected,
      selectedBackgroundColor = _ref7.selectedBackgroundColor,
      selectedFontWeight = _ref7.selectedFontWeight,
      selectedColor = _ref7.selectedColor;
  return interactive && selected &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("color:", selectedColor, ";font-weight:", selectedFontWeight, ";background-color:", selectedBackgroundColor, ";:active{background-color:", selectedBackgroundColor, ";}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/components/MenuList/MenuListItem.tsx


var MenuListItem_excluded = ["selectedIcon", "selected", "role", "tabIndex", "focused", "children", "value", "onClick", "tokens"];

function MenuListItem_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function MenuListItem_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? MenuListItem_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MenuListItem_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var BaseMenuListItem = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var selectedIcon = _ref.selectedIcon,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      role = _ref.role,
      tabIndex = _ref.tabIndex,
      focused = _ref.focused,
      children = _ref.children,
      value = _ref.value,
      _onClick = _ref.onClick,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, MenuListItem_excluded);

  var _useMenuListState = useMenuListState(),
      interactive = _useMenuListState.interactive,
      onInternalClick = _useMenuListState.onClick;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MenuListItem, MenuListItem_objectSpread(MenuListItem_objectSpread(MenuListItem_objectSpread({}, rest), {}, {
    onClick: function onClick(e) {
      onInternalClick === null || onInternalClick === void 0 ? void 0 : onInternalClick(e, value);
      _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
    },
    selected: selected,
    "aria-selected": selected,
    role: role,
    tabIndex: tabIndex,
    focused: focused,
    interactive: interactive,
    ref: ref
  }, tokens), {}, {
    children: [children, selected && selectedIcon]
  }));
});
var MenuListItem_MenuListItem = (0,useDesignTokens/* withDesignTokens */.Y)(BaseMenuListItem, function (props) {
  return {
    selectedFontWeight: 500,
    hasSelectedIcon: Boolean(props.selectedIcon)
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700],
      focusBackgroundColor: theme.palette.brand.darkAcai[100],
      activeBackgroundColor: theme.palette.brand.darkAcai[200],
      selectedBackgroundColor: theme.palette.brand.segmentGreen[100],
      selectedColor: theme.palette.brand.segmentGreen[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      focusBackgroundColor: (0,polished_esm/* transparentize */.DZ)(0.95, theme.palette.neutrals.white[100]),
      activeBackgroundColor: theme.palette.brand.darkAcai[500],
      selectedBackgroundColor: (0,polished_esm/* transparentize */.DZ)(0.95, theme.palette.brand.darkAcai[600]),
      selectedColor: theme.palette.brand.segmentGreen[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100],
      focusBackgroundColor: theme.palette.twilio.gray[10],
      activeBackgroundColor: theme.palette.twilio.gray[30],
      selectedBackgroundColor: theme.palette.twilio.blue[10],
      selectedColor: theme.palette.twilio.blue[60]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      color: theme.palette.twilio.gray[100],
      focusBackgroundColor: theme.palette.twilio.gray[10],
      activeBackgroundColor: theme.palette.twilio.gray[30],
      selectedBackgroundColor: theme.palette.twilio.blue[10],
      selectedColor: theme.palette.twilio.blue[60]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/components/MenuList/index.ts


MenuList_MenuList.displayName = "MenuListBase";
MenuListItem_MenuListItem.displayName = "MenuList.Item";


/***/ }),

/***/ 84672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SegmentLogo_SegmentLogo; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/components/SegmentLogo/SegmentLogo.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var SegmentLogo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1usxtsl1"
} : 0)( true ? {
  name: "9wwb2s",
  styles: "max-width:150px;display:inline-block;width:100%;max-height:41px;overflow:hidden"
} : 0);
var SvgLogo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("svg",  true ? {
  target: "e1usxtsl0"
} : 0)( true ? {
  name: "12p6xns",
  styles: "transform:scale(0.5) translateX(-50%) translateY(-50%)"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/SegmentLogo/SegmentLogo.tsx


var _excluded = ["tokens", "className", "openNavigation", "footer", "mono", "alt"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseSegmentLogo = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      className = _ref.className,
      _ref$openNavigation = _ref.openNavigation,
      openNavigation = _ref$openNavigation === void 0 ? false : _ref$openNavigation,
      _ref$footer = _ref.footer,
      footer = _ref$footer === void 0 ? false : _ref$footer,
      _ref$mono = _ref.mono,
      mono = _ref$mono === void 0 ? false : _ref$mono,
      alt = _ref.alt,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var color = (0,react.useMemo)(function () {
    if (footer) {
      return tokens.footerColor;
    }

    return openNavigation ? tokens.mobileColor : tokens.navColor;
  }, [openNavigation, footer, tokens]);
  var iconColor = (0,react.useMemo)(function () {
    if (mono) {
      return footer ? tokens.footerColor : tokens.navColor;
    }

    return tokens.iconColor;
  }, [mono, footer, tokens]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: className
  }, rest), tokens), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SvgLogo, {
      width: "300px",
      height: "81px",
      viewBox: "0 0 299 81",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
        children: alt
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        fill: iconColor,
        d: "M 68.128906 35.308594 L 35.503906 35.308594 C 34.261719 35.308594 33.242188 34.289062 33.242188 33.085938 L 33.242188 29.242188 C 33.242188 28.019531 34.28125 27.019531 35.503906 27.019531 L 68.335938 27.019531 C 69.578125 27.019531 70.597656 28.039062 70.597656 29.242188 L 70.597656 33.085938 C 70.390625 34.308594 69.351562 35.308594 68.128906 35.308594 Z M 68.128906 35.308594 "
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        fill: iconColor,
        d: "M 10.589844 51.921875 C 9.34375 51.921875 8.304688 50.882812 8.304688 49.640625 L 8.304688 45.691406 C 8.304688 44.652344 9.34375 43.617188 10.589844 43.617188 L 43.523438 43.617188 C 44.769531 43.617188 45.804688 44.652344 45.804688 45.898438 L 45.804688 49.847656 C 45.597656 50.882812 44.5625 51.921875 43.3125 51.921875 Z M 10.589844 51.921875 "
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        fill: iconColor,
        d: "M 20.660156 66.460938 C 22.945312 66.460938 24.8125 64.589844 24.8125 62.308594 C 24.8125 60.023438 22.945312 58.152344 20.660156 58.152344 C 18.375 58.152344 16.503906 60.023438 16.503906 62.308594 C 16.503906 64.589844 18.375 66.460938 20.660156 66.460938 Z M 20.660156 66.460938 "
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        fill: iconColor,
        d: "M 58.035156 20.769531 C 60.320312 20.769531 62.1875 18.898438 62.1875 16.617188 C 62.1875 14.332031 60.320312 12.460938 58.035156 12.460938 C 55.75 12.460938 53.878906 14.332031 53.878906 16.617188 C 53.878906 18.898438 55.75 20.769531 58.035156 20.769531 Z M 58.035156 20.769531 "
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        fill: iconColor,
        d: "M 39.347656 64.382812 C 37.0625 64.382812 34.78125 63.972656 32.703125 63.347656 C 31.664062 63.140625 30.625 63.554688 30.214844 64.589844 L 28.757812 68.539062 C 28.34375 69.578125 28.964844 70.824219 30.214844 71.238281 C 33.117188 72.277344 36.230469 72.691406 39.347656 72.691406 C 52.84375 72.691406 64.472656 64.589844 69.664062 52.960938 C 70.078125 51.921875 69.664062 50.472656 68.414062 50.054688 L 64.472656 48.601562 C 63.433594 48.183594 62.398438 48.601562 61.980469 49.640625 C 58.035156 58.359375 49.519531 64.382812 39.347656 64.382812 Z M 39.347656 64.382812 "
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        fill: iconColor,
        d: "M 39.347656 14.539062 C 41.632812 14.539062 43.917969 14.953125 45.992188 15.578125 C 47.03125 15.785156 48.070312 15.371094 48.484375 14.332031 L 49.9375 10.382812 C 50.351562 9.347656 49.726562 8.101562 48.484375 7.683594 C 45.574219 6.644531 42.460938 6.230469 39.347656 6.230469 C 25.847656 6.230469 14.222656 14.332031 9.03125 25.960938 C 8.617188 27 9.03125 28.453125 10.277344 28.871094 L 14.222656 30.324219 C 15.261719 30.738281 16.300781 30.324219 16.714844 29.285156 C 20.660156 20.5625 29.175781 14.539062 39.347656 14.539062 Z M 39.347656 14.539062 "
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        fill: color,
        d: "M 96.574219 66.480469 L 96.574219 62.058594 C 99.980469 65.421875 103.902344 67.1875 108.097656 67.1875 C 111.644531 67.1875 113.683594 65.484375 113.683594 62.808594 C 113.683594 59.441406 110.441406 59.066406 106.726562 58.652344 C 101.929688 58.09375 96.160156 57.363281 96.160156 51.089844 C 96.160156 45.839844 100.457031 42.785156 106.121094 42.785156 C 111.792969 42.785156 115.113281 44.675781 117.375 46.417969 L 117.375 50.804688 C 114.472656 47.75 110.648438 46.230469 106.269531 46.191406 C 102.300781 46.191406 100.371094 48.042969 100.371094 50.71875 C 100.371094 53.8125 103.738281 54.273438 107.472656 54.683594 C 112.3125 55.246094 118 56.078125 118 62.472656 C 118 67.417969 114.222656 70.675781 108.304688 70.675781 C 102.386719 70.675781 99.3125 68.832031 96.59375 66.480469 Z M 96.574219 66.480469 "
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        fill: color,
        d: "M 121.53125 56.429688 C 121.53125 47.976562 126.785156 42.761719 134.074219 42.761719 C 140.945312 42.761719 145.886719 46.957031 145.886719 55.722656 L 145.886719 57.800781 L 125.867188 57.800781 C 126.246094 64.445312 130.707031 67.085938 136.816406 67.085938 C 140.882812 67.085938 143.496094 65.609375 145.347656 64.09375 L 145.347656 67.980469 C 143.871094 69.140625 141.152344 70.695312 136.0625 70.695312 C 127.03125 70.695312 121.53125 65.714844 121.53125 57.09375 Z M 125.914062 54.582031 L 141.546875 54.582031 C 141.277344 48.953125 138.492188 46.191406 134.03125 46.191406 C 129.566406 46.191406 126.515625 48.914062 125.914062 54.582031 Z M 125.914062 54.582031 "
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        fill: color,
        d: "M 148.480469 75.164062 C 148.480469 72.171875 150.785156 69.992188 156.1875 69.617188 C 156.226562 69.617188 156.269531 69.578125 156.269531 69.535156 C 156.269531 69.496094 156.226562 69.449219 156.1875 69.449219 C 151.429688 69.449219 149.6875 68.292969 149.6875 65.984375 C 149.6875 63.867188 151.910156 61.871094 157.308594 61.828125 C 157.347656 61.828125 157.390625 61.789062 157.390625 61.746094 C 157.390625 61.707031 157.347656 61.664062 157.308594 61.664062 C 152.59375 60.976562 149.832031 57.65625 149.832031 52.628906 C 149.832031 46.730469 154.359375 42.804688 161 42.804688 C 164.09375 42.804688 165.570312 43.261719 167.542969 43.261719 L 174.6875 43.261719 L 174.6875 46.769531 L 169.207031 46.769531 C 170.949219 48.015625 172.070312 50.40625 172.070312 53.042969 C 172.070312 58.214844 168.0625 62.367188 161.230469 62.367188 L 159.570312 62.367188 C 155.875 62.367188 153.945312 63.160156 153.945312 64.53125 C 153.945312 66.003906 155.230469 66.234375 160.128906 66.234375 L 165.074219 66.234375 C 171.382812 66.234375 174.582031 67.851562 174.582031 72.464844 C 174.582031 77.074219 170.617188 80.726562 160.648438 80.726562 L 160.007812 80.726562 C 151.203125 80.726562 148.523438 78.507812 148.523438 75.183594 Z M 170.34375 73.085938 C 170.34375 70.59375 168.3125 69.949219 164.160156 69.949219 L 159.777344 69.949219 C 154.523438 69.949219 152.71875 71.839844 152.71875 74.023438 C 152.71875 76.015625 154.710938 77.386719 160.378906 77.386719 L 160.878906 77.386719 C 167.792969 77.386719 170.324219 75.726562 170.324219 73.085938 Z M 167.894531 52.734375 C 167.894531 48.847656 165.445312 45.816406 160.980469 45.816406 C 156.519531 45.816406 154.027344 48.496094 154.027344 52.734375 C 154.027344 56.429688 156.476562 59.234375 160.980469 59.234375 C 165.488281 59.234375 167.894531 56.429688 167.894531 52.734375 Z M 167.894531 52.734375 "
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        fill: color,
        d: "M 178.296875 43.242188 L 182.535156 43.242188 L 182.535156 52.382812 C 183.324219 45.734375 186.316406 42.785156 191.527344 42.785156 C 197.382812 42.785156 200.433594 46.191406 200.929688 52.050781 C 201.722656 45.859375 204.75 42.785156 209.960938 42.785156 C 216.335938 42.785156 219.515625 47.023438 219.515625 54.125 L 219.515625 70.222656 L 215.21875 70.222656 L 215.21875 54.957031 C 215.21875 49.785156 213.183594 46.316406 208.304688 46.316406 C 204.109375 46.316406 201.015625 49.554688 201.058594 55.308594 L 201.058594 70.222656 L 196.757812 70.222656 L 196.757812 54.625 C 196.757812 49.679688 194.683594 46.316406 189.84375 46.316406 C 185.730469 46.316406 182.554688 49.554688 182.554688 55.828125 L 182.554688 70.222656 L 178.257812 70.222656 L 178.257812 43.222656 Z M 178.296875 43.242188 "
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        fill: color,
        d: "M 223.917969 56.429688 C 223.917969 47.976562 229.167969 42.761719 236.460938 42.761719 C 243.332031 42.761719 248.273438 46.957031 248.273438 55.722656 L 248.273438 57.800781 L 228.257812 57.800781 C 228.628906 64.445312 233.09375 67.085938 239.199219 67.085938 C 243.269531 67.085938 245.886719 65.609375 247.734375 64.09375 L 247.734375 67.980469 C 246.257812 69.140625 243.539062 70.695312 238.453125 70.695312 C 229.421875 70.695312 223.917969 65.714844 223.917969 57.09375 Z M 228.296875 54.582031 L 243.933594 54.582031 C 243.664062 48.953125 240.882812 46.191406 236.417969 46.191406 C 231.957031 46.191406 228.902344 48.914062 228.296875 54.582031 Z M 228.296875 54.582031 "
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        fill: color,
        d: "M 257.058594 43.242188 L 257.058594 52.335938 C 257.972656 45.503906 261.4375 42.785156 266.570312 42.785156 C 273.484375 42.785156 276.804688 47.082031 276.804688 54.414062 L 276.804688 70.242188 L 272.503906 70.242188 L 272.503906 55.285156 C 272.503906 49.804688 270.34375 46.335938 264.988281 46.335938 C 260.503906 46.335938 257.097656 49.742188 257.097656 56.304688 L 257.097656 70.242188 L 252.800781 70.242188 L 252.800781 43.242188 Z M 257.058594 43.242188 "
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        fill: color,
        d: "M 284.050781 62.058594 L 284.050781 46.730469 L 279.167969 46.730469 L 279.167969 43.636719 L 280.644531 43.59375 C 283.449219 43.449219 284.339844 42.390625 284.570312 38.984375 L 284.710938 36.992188 L 288.347656 36.992188 L 288.347656 43.222656 L 297.523438 43.222656 L 297.523438 46.730469 L 288.347656 46.730469 L 288.347656 61.914062 C 288.347656 65.421875 289.96875 66.980469 293.144531 66.980469 C 294.808594 66.980469 296.464844 66.609375 297.523438 65.921875 L 297.523438 69.285156 C 296.464844 69.96875 294.574219 70.574219 291.941406 70.574219 C 286.5 70.574219 284.050781 67.9375 284.050781 62.035156 Z M 284.050781 62.058594 "
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        fill: color,
        d: "M 118.980469 30.613281 L 113.164062 9.992188 L 113.164062 15.449219 C 113.164062 15.742188 112.976562 15.929688 112.683594 15.929688 L 108.863281 15.929688 L 108.863281 21.683594 C 108.863281 23.738281 109.382812 24.34375 111.027344 24.34375 C 111.644531 24.34375 112.25 24.296875 112.789062 24.050781 C 113.203125 23.84375 113.515625 24.011719 113.515625 24.34375 L 113.515625 30.136719 C 113.515625 30.46875 113.390625 30.675781 113.082031 30.820312 C 112.019531 31.320312 110.007812 31.632812 107.558594 31.632812 C 101.222656 31.632812 99.148438 28.640625 99.148438 23.367188 L 99.148438 15.910156 L 96.011719 15.910156 C 95.722656 15.910156 95.515625 15.703125 95.515625 15.410156 L 95.515625 9.285156 C 95.515625 8.992188 95.722656 8.785156 96.011719 8.785156 L 98.109375 8.785156 C 98.960938 8.785156 99.417969 8.414062 99.417969 7.5625 L 99.417969 4.113281 C 99.417969 3.820312 99.585938 3.574219 99.875 3.488281 L 107.992188 0.871094 C 108.410156 0.746094 108.65625 0.914062 108.65625 1.285156 L 108.65625 8.578125 L 121.574219 8.578125 C 121.863281 8.578125 122.027344 8.699219 122.113281 9.035156 L 124.003906 18.941406 L 125.894531 9.035156 C 125.933594 8.746094 126.140625 8.578125 126.433594 8.578125 L 135.089844 8.578125 C 135.378906 8.578125 135.589844 8.746094 135.628906 9.035156 L 137.582031 18.941406 L 139.511719 9.035156 C 139.597656 8.699219 139.761719 8.578125 140.050781 8.578125 L 157.101562 8.578125 C 157.390625 8.578125 157.597656 8.785156 157.597656 9.074219 L 157.597656 30.507812 C 157.597656 30.800781 157.390625 31.007812 157.101562 31.007812 L 148.335938 31.007812 C 148.046875 31.007812 147.835938 30.800781 147.835938 30.507812 L 147.835938 9.992188 L 142.273438 30.613281 C 142.191406 30.90625 141.984375 31.027344 141.652344 31.027344 L 133.699219 31.027344 C 133.40625 31.027344 133.28125 30.90625 133.199219 30.613281 L 130.644531 20.875 L 128.011719 30.613281 C 127.925781 30.90625 127.804688 31.027344 127.511719 31.027344 L 119.558594 31.027344 C 119.226562 31.027344 119.019531 30.90625 118.933594 30.613281 Z M 147.835938 6.167969 C 147.835938 6.457031 148.046875 6.667969 148.335938 6.667969 L 157.101562 6.667969 C 157.390625 6.667969 157.597656 6.457031 157.597656 6.167969 L 157.597656 1.332031 C 157.597656 1.039062 157.390625 0.832031 157.101562 0.832031 L 148.335938 0.832031 C 148.046875 0.832031 147.835938 1.039062 147.835938 1.332031 L 147.835938 6.191406 Z M 159.527344 30.527344 C 159.527344 30.820312 159.734375 31.027344 160.027344 31.027344 L 168.789062 31.027344 C 169.078125 31.027344 169.285156 30.820312 169.285156 30.527344 L 169.285156 1.332031 C 169.285156 1.039062 169.078125 0.832031 168.789062 0.832031 L 160.027344 0.832031 C 159.734375 0.832031 159.527344 1.039062 159.527344 1.332031 L 159.527344 30.554688 Z M 171.222656 30.527344 C 171.222656 30.820312 171.429688 31.027344 171.714844 31.027344 L 180.460938 31.027344 C 180.75 31.027344 180.957031 30.820312 180.957031 30.527344 L 180.957031 9.117188 C 180.957031 8.828125 180.75 8.621094 180.460938 8.621094 L 171.714844 8.621094 C 171.429688 8.621094 171.222656 8.828125 171.222656 9.117188 L 171.222656 30.554688 Z M 171.222656 6.167969 C 171.222656 6.457031 171.429688 6.667969 171.714844 6.667969 L 180.460938 6.667969 C 180.75 6.667969 180.957031 6.457031 180.957031 6.167969 L 180.957031 1.332031 C 180.957031 1.039062 180.75 0.832031 180.460938 0.832031 L 171.714844 0.832031 C 171.429688 0.832031 171.222656 1.039062 171.222656 1.332031 L 171.222656 6.191406 Z M 207.640625 19.484375 L 207.640625 20.023438 C 207.640625 26.6875 202.574219 31.714844 195.074219 31.714844 C 187.582031 31.714844 182.476562 26.6875 182.476562 20.023438 L 182.476562 19.484375 C 182.476562 12.816406 187.601562 7.933594 195.074219 7.933594 C 202.554688 7.933594 207.640625 12.816406 207.640625 19.484375 Z M 198.296875 19.625 C 198.296875 16.554688 196.882812 15.351562 195.074219 15.351562 C 193.269531 15.351562 191.859375 16.554688 191.859375 19.625 L 191.859375 20.023438 C 191.859375 23.054688 193.269531 24.324219 195.074219 24.324219 C 196.882812 24.324219 198.296875 23.054688 198.296875 20.023438 Z M 198.296875 19.625 "
      })]
    })
  }));
});
var SegmentLogo_SegmentLogo = (0,useDesignTokens/* withDesignTokens */.Y)(BaseSegmentLogo, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      iconColor: theme.palette.logo.green[10],
      navColor: theme.palette.twilio.gray[100],
      mobileColor: theme.palette.twilio.gray[100],
      footerColor: theme.palette.twilio.gray[100]
    };
  },
  dark: function dark(theme) {
    return {
      iconColor: theme.palette.logo.green[10],
      navColor: theme.palette.neutrals.white[100],
      mobileColor: theme.palette.twilio.gray[100],
      footerColor: theme.palette.neutrals.white[100]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      iconColor: theme.palette.logo.green[10],
      navColor: theme.palette.twilio.gray[100],
      mobileColor: theme.palette.twilio.gray[100],
      footerColor: theme.palette.neutrals.white[100]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      iconColor: theme.palette.logo.green[10],
      navColor: theme.palette.neutrals.white[100],
      mobileColor: theme.palette.twilio.gray[100],
      footerColor: theme.palette.neutrals.white[100]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      iconColor: theme.palette.logo.green[10],
      navColor: theme.palette.neutrals.white[100],
      mobileColor: theme.palette.twilio.gray[100],
      footerColor: theme.palette.neutrals.white[100]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/components/SegmentLogo/index.ts


/***/ }),

/***/ 65016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Typography_Typography; }
});

// UNUSED EXPORTS: BaseTypography

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js
var emotion_is_prop_valid_esm = __webpack_require__(86015);
;// CONCATENATED MODULE: ../../libs/matcha/components/Typography/Typography.views.tsx


var Typography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return (0,emotion_is_prop_valid_esm/* default */.Z)(prop) && prop !== "color";
  },
  target: "evezdik0"
} : 0)("color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";margin:24px 0;a{text-decoration:underline;transition:color 0.3s ease-in-out;color:", function (_ref2) {
  var linkColor = _ref2.linkColor;
  return linkColor;
}, ";:hover{color:", function (_ref3) {
  var linkHoverColor = _ref3.linkHoverColor;
  return linkHoverColor;
}, ";}}", function (_ref4) {
  var theme = _ref4.theme,
      variant = _ref4.variant;
  return theme.typography[variant].css;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Typography/Typography.tsx


var _excluded = ["variant", "tag", "appearance", "children", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var getElementTag = function getElementTag(variant) {
  switch (variant) {
    case "pExtraLarge":
    case "pExtraLargeBold":
    case "pLarge":
    case "pLargeBold":
    case "pMedium":
    case "pMediumBold":
    case "pSmall":
    case "pSmallBold":
      return "p";

    case "textBold":
    case "textBoldSmall":
    case "textRegularSmall":
    case "textTiny":
    case "buttonLarge":
    case "buttonSmall":
    case "buttonTextLarge":
    case "buttonTextMedium":
    case "buttonTextSmall":
    case "formInput":
    case "formHint":
    case "overline":
      return "span";

    case "formLabel":
      return "label";

    case "code":
      return "pre";

    case "h1":
      return "h1";

    case "h2":
      return "h2";

    case "h3":
      return "h3";

    case "h4":
      return "h4";

    case "h5":
      return "h5";

    case "h6":
      return "h6";

    default:
      throw new Error("Unsupported typography variant \"".concat(variant, "\""));
  }
};

var BaseTypography = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var variant = _ref.variant,
      tag = _ref.tag,
      externalAppearance = _ref.appearance,
      children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: appearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography, _objectSpread(_objectSpread(_objectSpread({
      as: tag !== null && tag !== void 0 ? tag : getElementTag(variant),
      ref: ref,
      variant: variant
    }, rest), tokens), {}, {
      children: children
    }))
  });
});
var Typography_Typography = (0,useDesignTokens/* withDesignTokens */.Y)(BaseTypography, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700],
      linkColor: theme.palette.brand.segmentGreen[500],
      linkHoverColor: theme.palette.brand.segmentGreen[400]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      linkColor: theme.palette.brand.darkAcai[400],
      linkHoverColor: theme.palette.brand.darkAcai[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100],
      linkColor: theme.palette.twilio.blue[60],
      linkHoverColor: theme.palette.twilio.blue[80]
    };
  },
  twilioDark: function twilioDark(theme) {
    // eslint-disable-next-line no-warning-comments
    // TODO: Replace with twilioDark color
    return {
      color: theme.palette.neutrals.white[100],
      linkColor: theme.palette.twilio.blue[60],
      linkHoverColor: theme.palette.twilio.blue[80]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      linkColor: theme.palette.cdpWeek2023.blue[40],
      linkHoverColor: theme.palette.cdpWeek2023.blue[60]
    };
  }
});

/***/ }),

/***/ 89533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Typography__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65016);


/***/ }),

/***/ 9381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* reexport */ AppearanceProvider; },
  "M": function() { return /* reexport */ useAppearance; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/foundations/AppearanceContext/AppearanceContext.tsx


var AppearanceContext = /*#__PURE__*/(0,react.createContext)(null);
var AppearanceProvider = function AppearanceProvider(_ref) {
  var appearance = _ref.appearance,
      children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext.Provider, {
    value: appearance !== null && appearance !== void 0 ? appearance : null,
    children: children
  });
};
var useAppearance = function useAppearance(appearance) {
  var _ref3;

  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      defaultAppearance = _ref2.defaultAppearance;

  var scopedAppearance = (0,react.useContext)(AppearanceContext);
  var finalAppearance = (_ref3 = appearance !== null && appearance !== void 0 ? appearance : scopedAppearance) !== null && _ref3 !== void 0 ? _ref3 : defaultAppearance;

  if (finalAppearance === null || finalAppearance === undefined) {
    if (true) throw new Error();else {}
  }

  return finalAppearance;
};
;// CONCATENATED MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts


/***/ }),

/***/ 63115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ToggleIcon_ToggleIcon; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/ToggleIcon/assets/ChevronDown.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M2 4L5.78462 7.90382C5.81224 7.93418 5.8456 7.95838 5.88265 7.97492C5.91969 7.99147 5.95963 8 6 8C6.04037 8 6.08031 7.99147 6.11735 7.97492C6.1544 7.95838 6.18776 7.93418 6.21538 7.90382L10 4",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var ChevronDown = (SvgChevronDown);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/ToggleIcon/assets/ChevronUp.svg
var ChevronUp_path;
function ChevronUp_extends() { ChevronUp_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ChevronUp_extends.apply(this, arguments); }

var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/react.createElement("svg", ChevronUp_extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), ChevronUp_path || (ChevronUp_path = /*#__PURE__*/react.createElement("path", {
    d: "M2 8L5.78462 4.09618C5.81224 4.06582 5.8456 4.04162 5.88265 4.02508C5.91969 4.00853 5.95963 4 6 4C6.04037 4 6.08031 4.00853 6.11735 4.02508C6.1544 4.04162 6.18776 4.06582 6.21538 4.09618L10 8",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var ChevronUp = (SvgChevronUp);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/ToggleIcon/ToggleIcon.tsx




var ToggleIcon = function ToggleIcon(_ref) {
  var open = _ref.open;
  var Icon = open ? ChevronUp : ChevronDown;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {});
};

/* harmony default export */ var ToggleIcon_ToggleIcon = (ToggleIcon);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/ToggleIcon/index.ts


/***/ }),

/***/ 77966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xN": function() { return /* reexport */ Navbar_Aside_Aside; },
  "H2": function() { return /* reexport */ Brand_Brand; },
  "VY": function() { return /* reexport */ Navbar_Content_Content; },
  "rU": function() { return /* reexport */ Navbar_Link_Link; },
  "ZP": function() { return /* reexport */ DesktopNavigation_Navbar_Navbar; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Elevation/index.ts + 2 modules
var Elevation = __webpack_require__(33606);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/Navbar.views.ts


var Navbar = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Elevation/* default */.Z,  true ? {
  target: "e1pxt0y51"
} : 0)("position:relative;width:100%;padding:16px 32px;background-color:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1pxt0y50"
} : 0)("max-width:1440px;margin:0 auto;display:flex;justify-content:space-between;align-items:center;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("xl");
}, "{justify-content:center;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/Navbar.tsx


var _excluded = ["children", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseNavbar = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar, _objectSpread(_objectSpread(_objectSpread({
    elevation: 2
  }, tokens), rest), {}, {
    ref: ref,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
      children: children
    })
  }));
});
var Navbar_Navbar = (0,useDesignTokens/* withDesignTokens */.Y)(BaseNavbar, function (_props, theme) {
  return {
    backgroundColor: theme.palette.neutrals.white[100]
  };
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});
/* harmony default export */ var DesktopNavigation_Navbar_Navbar = (Navbar_Navbar);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/Brand/Brand.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1n415yu1"
} : 0)("height:100%;display:flex;justify-content:start;align-items:center;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("xl");
}, "{flex:1;}" + ( true ? "" : 0));
var Link = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e1n415yu0"
} : 0)( true ? {
  name: "1tjf9n0",
  styles: "height:100%;width:150px;text-decoration:none;display:inline-block"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/Brand/Brand.tsx


var Brand_excluded = ["href", "onClick", "children"];

function Brand_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Brand_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Brand_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Brand_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Brand = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _ref$href = _ref.href,
      href = _ref$href === void 0 ? "/" : _ref$href,
      onClick = _ref.onClick,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Brand_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, Brand_objectSpread(Brand_objectSpread({}, rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link, {
      href: href,
      onClick: onClick,
      ref: ref,
      children: children
    })
  }));
});
/* harmony default export */ var Brand_Brand = (Brand);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/Brand/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/Content/Content.views.ts

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "ek176p60"
} : 0)("display:flex;justify-content:space-between;gap:16px;align-items:center;height:100%;min-height:0;padding:0;list-style:none;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("xl");
}, "{gap:24px;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/Content/Content.tsx


var Content_excluded = ["children", "tokens"];

function Content_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Content_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Content_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Content_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseContent = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Content_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content, Content_objectSpread(Content_objectSpread(Content_objectSpread({
    ref: ref
  }, tokens), rest), {}, {
    children: children
  }));
});
var Content_Content = (0,useDesignTokens/* withDesignTokens */.Y)(BaseContent, function () {
  return {};
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});
/* harmony default export */ var Navbar_Content_Content = (Content_Content);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/Content/index.ts

// EXTERNAL MODULE: ../../node_modules/react-use/esm/useClickAway.js
var useClickAway = __webpack_require__(27866);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/ToggleIcon/index.ts + 3 modules
var ToggleIcon = __webpack_require__(63115);
// EXTERNAL MODULE: ../../libs/matcha/foundations/Theme/theme.ts + 2 modules
var theme = __webpack_require__(15076);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/Link/Link.views.ts


function Link_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Link_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e15jkpr22"
} : 0)( true ? "" : 0);
var Link_views_Link = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e15jkpr21"
} : 0)("display:flex;justify-content:space-between;align-items:center;gap:6px;cursor:pointer;font-size:16px;font-weight:500;line-height:25px;font-family:", theme/* WHITNEY_FONT */.ef, ";color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";text-decoration:none;&:hover{color:", function (_ref2) {
  var hoverColor = _ref2.hoverColor;
  return hoverColor;
}, ";}&[aria-expanded='true']{color:", function (_ref3) {
  var openColor = _ref3.openColor;
  return openColor;
}, ";}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("xl");
}, "{font-size:18px;}" + ( true ? "" : 0));
var DropdownWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e15jkpr20"
} : 0)( true ? {
  name: "1qdkase",
  styles: "position:absolute;left:50%;transform:translateX(-50%);top:100%"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/Link/Link.tsx


var Link_excluded = ["children", "title", "href", "open", "tokens", "onClick", "onClickAway", "role"];

function Link_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Link_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Link_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Link_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var BaseLink = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      title = _ref.title,
      href = _ref.href,
      open = _ref.open,
      tokens = _ref.tokens,
      onClick = _ref.onClick,
      onClickAway = _ref.onClickAway,
      role = _ref.role,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Link_excluded);

  var id = (0,react.useId)();
  var dropDownId = "dropdown-".concat(id);
  var wrapperRef = (0,react.useRef)(null);
  (0,useClickAway/* default */.Z)(wrapperRef, function () {
    if (open) {
      onClickAway === null || onClickAway === void 0 ? void 0 : onClickAway();
    }
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link_views_Wrapper, {
    ref: wrapperRef,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link_views_Link, Link_objectSpread(Link_objectSpread(Link_objectSpread(Link_objectSpread({}, href ? {
      as: "a",
      href: href
    } : {
      'aria-controls': dropDownId,
      'aria-expanded': open
    }), {}, {
      ref: ref,
      role: role,
      onClick: onClick
    }, tokens), rest), {}, {
      children: [title, typeof open === "boolean" && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleIcon/* default */.Z, {
        open: open
      })]
    })), open && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropdownWrapper, {
      id: dropDownId,
      children: children
    })]
  });
});
var Link_Link = (0,useDesignTokens/* withDesignTokens */.Y)(BaseLink, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100],
    openColor: theme.palette.twilio.blue[60],
    hoverColor: theme.palette.twilio.blue[60]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      openColor: theme.palette.brand.segmentGreen[500],
      hoverColor: theme.palette.brand.segmentGreen[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      openColor: theme.palette.brand.segmentGreen[500],
      hoverColor: theme.palette.brand.segmentGreen[500]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});
/* harmony default export */ var Navbar_Link_Link = (Link_Link);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/Link/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/Aside/Aside.views.ts

var Aside = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "effmuv20"
} : 0)("display:flex;align-items:center;justify-content:end;gap:16px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("xl");
}, "{flex:1;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/Aside/Aside.tsx


var Aside_excluded = ["children", "tokens"];

function Aside_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Aside_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Aside_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Aside_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseAside = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Aside_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Aside, Aside_objectSpread(Aside_objectSpread(Aside_objectSpread({
    ref: ref
  }, tokens), rest), {}, {
    children: children
  }));
});
var Aside_Aside = (0,useDesignTokens/* withDesignTokens */.Y)(BaseAside, function () {
  return {};
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});
/* harmony default export */ var Navbar_Aside_Aside = (Aside_Aside);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/Aside/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/index.ts






/***/ }),

/***/ 82680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rU": function() { return /* reexport */ DesktopNavigation_Link_Link; },
  "xc": function() { return /* reexport */ LinkHighlighted_LinkHighlighted; },
  "aV": function() { return /* reexport */ DesktopNavigation_List_List; },
  "wp": function() { return /* reexport */ Navbar/* default */.ZP; },
  "pm": function() { return /* reexport */ DesktopNavigation_Subheading_Subheading; },
  "Ll": function() { return /* reexport */ DesktopNavigation_SupportLink_SupportLink; },
  "UK": function() { return /* reexport */ SupportMenu; },
  "T8": function() { return /* reexport */ UtilityNav_UtilityNav; },
  "ZP": function() { return /* reexport */ DesktopNavigation_DesktopNavigation; }
});

// UNUSED EXPORTS: Heading

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/DesktopNavigation.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var DesktopNavigation = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    ref: ref,
    children: children
  });
});

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("nav",  true ? {
  target: "e1iq8l410"
} : 0)( true ? {
  name: "10syivw",
  styles: "position:sticky;top:0;left:0;z-index:999;width:100%"
} : 0);

/* harmony default export */ var DesktopNavigation_DesktopNavigation = (DesktopNavigation);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/UtilityNav/UtilityNav.views.ts


function UtilityNav_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1hqe4zx5"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
var DescriptionSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hqe4zx4"
} : 0)( true ? {
  name: "1auxtb1",
  styles: "display:inline-flex;justify-content:center"
} : 0);
var AsideSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hqe4zx3"
} : 0)( true ? {
  name: "1r9eqj5",
  styles: "display:flex;gap:16px"
} : 0);
var CtaLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e1hqe4zx2"
} : 0)("font-size:", function (_ref) {
  var theme = _ref.theme;
  return theme.typography.buttonSmall;
}, ";margin:0 8px;padding:0;&:after{height:1px;bottom:-2px;}" + ( true ? "" : 0));
var UtilityNav_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hqe4zx1"
} : 0)("width:100%;background:", function (_ref2) {
  var background = _ref2.background;
  return background;
}, ";padding:12px 32px;" + ( true ? "" : 0));
var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hqe4zx0"
} : 0)( true ? {
  name: "h1h4sr",
  styles: "max-width:1440px;margin:0 auto;display:flex;justify-content:space-between;align-items:center"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/UtilityNav/UtilityNav.tsx


var _excluded = ["announcement", "tokens", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var UtilityNavBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _announcement$descrip;

  var announcement = _ref.announcement,
      tokens = _ref.tokens,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var description = typeof (announcement === null || announcement === void 0 ? void 0 : announcement.description) === "string" ? announcement.description : announcement === null || announcement === void 0 ? void 0 : (_announcement$descrip = announcement.description) === null || _announcement$descrip === void 0 ? void 0 : _announcement$descrip.md;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UtilityNav_views_Wrapper, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    background: tokens.background,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionSlot, {
        children: announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
            variant: "buttonSmall",
            children: description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaLink, {
            tokens: _objectSpread({}, tokens.buttonText),
            size: "small",
            href: announcement.ctaLink,
            hover: true,
            children: announcement.ctaTitle
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AsideSlot, {
        children: children
      })]
    })
  }));
});
var UtilityNav = (0,useDesignTokens/* withDesignTokens */.Y)(UtilityNavBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  light: function light(theme) {
    return {
      background: theme.palette.brand.darkAcai[700],
      buttonText: {
        textColor: theme.palette.neutrals.white[100],
        hoverColor: theme.palette.brand.darkAcai[200]
      }
    };
  },
  dark: function dark(theme) {
    return {
      background: theme.palette.brand.darkAcai[700],
      buttonText: {
        textColor: theme.palette.neutrals.white[100],
        hoverColor: theme.palette.brand.darkAcai[200]
      }
    };
  }
});
/* harmony default export */ var UtilityNav_UtilityNav = (UtilityNav);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Heading/Heading.views.ts


var Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e163uk2g0"
} : 0)("margin:0;font-weight:600;color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Heading/Heading.tsx




var HeadingBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
    variant: "pLarge",
    color: tokens.color,
    ref: ref,
    children: children
  });
});
var Heading_Heading = (0,useDesignTokens/* withDesignTokens */.Y)(HeadingBase, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});
/* harmony default export */ var DesktopNavigation_Heading_Heading = ((/* unused pure expression or super */ null && (Heading_Heading)));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Heading/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/List/List.views.ts


function List_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var List = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "ewyol5q0"
} : 0)( true ? {
  name: "9yyqsh",
  styles: "list-style-type:none;padding:24px 0;display:flex;gap:16px;flex-direction:column"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/List/List.tsx



var List_List = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, {
    ref: ref,
    role: "menu",
    children: children
  });
});
/* harmony default export */ var DesktopNavigation_List_List = (List_List);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/List/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Link/Link.views.ts


function Link_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evvhund3"
} : 0)( true ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : 0);
var Link = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "evvhund2"
} : 0)("position:relative;margin:0;color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";padding:2px 0;margin-right:8px;&::before{content:'';position:absolute;bottom:-2px;left:0;width:100%;height:1px;background-color:", function (_ref2) {
  var lineColor = _ref2.lineColor;
  return lineColor;
}, ";opacity:0;}&[aria-expanded='true']{color:", function (_ref3) {
  var openColor = _ref3.openColor;
  return openColor;
}, ";&+span{color:", function (_ref4) {
  var openColor = _ref4.openColor;
  return openColor;
}, ";}}" + ( true ? "" : 0));
var Link_views_Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "evvhund1"
} : 0)("line-height:1.5;display:inline-block;margin-top:4px;margin-bottom:0;color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.twilio.gray[60];
}, ";" + ( true ? "" : 0));
var Link_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "evvhund0"
} : 0)("display:inline-flex;gap:16px;text-align:left;text-decoration:none;cursor:pointer;&:hover{", Link, "{&::before{opacity:1;}}}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Link/Link.tsx


var Link_excluded = ["title", "href", "description", "iconStart", "iconEnd", "onClick", "tokens"];

function Link_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Link_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Link_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Link_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseLink = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var title = _ref.title,
      href = _ref.href,
      description = _ref.description,
      IconStart = _ref.iconStart,
      IconEnd = _ref.iconEnd,
      onClick = _ref.onClick,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Link_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link_views_Wrapper, Link_objectSpread(Link_objectSpread({
    href: href,
    as: href ? "a" : "button",
    onClick: onClick,
    role: "menuitem"
  }, rest), {}, {
    children: [IconStart && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconStart, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Title, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link, Link_objectSpread(Link_objectSpread({
          variant: "pSmallBold",
          ref: ref
        }, tokens), {}, {
          children: title
        })), IconEnd && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconEnd, {})]
      }), description && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link_views_Description, {
        variant: "textRegularSmall",
        children: description
      })]
    })]
  }));
});
var Link_Link = (0,useDesignTokens/* withDesignTokens */.Y)(BaseLink, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100],
    openColor: theme.palette.twilio.blue[60],
    lineColor: theme.palette.twilio.blue[60]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[900],
      openColor: theme.palette.brand.segmentGreen[500],
      lineColor: theme.palette.brand.segmentGreen[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[900],
      openColor: theme.palette.brand.segmentGreen[500],
      lineColor: theme.palette.brand.segmentGreen[500]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});
/* harmony default export */ var DesktopNavigation_Link_Link = (Link_Link);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Link/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Subheading/Subheading.views.ts


var Subheading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e17yg3rz1"
} : 0)("margin:0;font-weight:600;color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";" + ( true ? "" : 0));
var Subheading_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e17yg3rz0"
} : 0)( true ? "" : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Subheading/Subheading.tsx






var BaseSubheading = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Subheading_views_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subheading, {
      variant: "pSmall",
      ref: ref,
      color: tokens.color,
      children: children
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})]
  });
});
var Subheading_Subheading = (0,useDesignTokens/* withDesignTokens */.Y)(BaseSubheading, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100]
  };
}, {
  light: function light() {
    return {};
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  }
});
/* harmony default export */ var DesktopNavigation_Subheading_Subheading = (Subheading_Subheading);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Subheading/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/LinkHighlighted/LinkHighlighted.views.ts


var LinkHighlighted_views_Link = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "elpqorw2"
} : 0)("position:relative;margin:0;color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";&::before{content:'';position:absolute;bottom:-2px;left:0;width:100%;height:1px;background-color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";}" + ( true ? "" : 0));
var Icon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "elpqorw1"
} : 0)("color:", function (_ref3) {
  var color = _ref3.color;
  return color;
}, ";" + ( true ? "" : 0));
var LinkHighlighted_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "elpqorw0"
} : 0)("display:inline-flex;gap:6px;text-align:left;text-decoration:none;cursor:pointer;&:hover{", Icon, "{color:", function (_ref4) {
  var hoverColor = _ref4.hoverColor;
  return hoverColor;
}, ";}", LinkHighlighted_views_Link, "{&::before{background-color:", function (_ref5) {
  var hoverColor = _ref5.hoverColor;
  return hoverColor;
}, ";}}}&:active{", Icon, "{color:", function (_ref6) {
  var activeColor = _ref6.activeColor;
  return activeColor;
}, ";}", LinkHighlighted_views_Link, "{color:", function (_ref7) {
  var activeColor = _ref7.activeColor;
  return activeColor;
}, ";&::before{background-color:", function (_ref8) {
  var activeColor = _ref8.activeColor;
  return activeColor;
}, ";}}}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/LinkHighlighted/LinkHighlighted.tsx


var LinkHighlighted_excluded = ["title", "href", "iconEnd", "tokens", "onClick"];

function LinkHighlighted_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function LinkHighlighted_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? LinkHighlighted_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LinkHighlighted_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseLinkHighlighted = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var title = _ref.title,
      href = _ref.href,
      IconEnd = _ref.iconEnd,
      tokens = _ref.tokens,
      onClick = _ref.onClick,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, LinkHighlighted_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LinkHighlighted_views_Wrapper, LinkHighlighted_objectSpread(LinkHighlighted_objectSpread({
    role: "menuitem",
    href: href,
    onClick: onClick
  }, tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkHighlighted_views_Link, LinkHighlighted_objectSpread(LinkHighlighted_objectSpread(LinkHighlighted_objectSpread({
      variant: "pSmallBold",
      ref: ref
    }, tokens.link), rest), {}, {
      children: title
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, LinkHighlighted_objectSpread(LinkHighlighted_objectSpread({}, tokens.link), {}, {
      children: IconEnd && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconEnd, {
        size: "small"
      })
    }))]
  }));
});
var LinkHighlighted = (0,useDesignTokens/* withDesignTokens */.Y)(BaseLinkHighlighted, function (_props, theme) {
  return {
    link: {
      color: theme.palette.twilio.gray[100]
    },
    hoverColor: theme.palette.twilio.blue[60],
    activeColor: theme.palette.twilio.blue[60]
  };
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});
/* harmony default export */ var LinkHighlighted_LinkHighlighted = (LinkHighlighted);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/LinkHighlighted/index.ts

// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/index.ts + 14 modules
var Navbar = __webpack_require__(77966);
// EXTERNAL MODULE: ../../libs/matcha/components/MenuList/index.ts + 5 modules
var components_MenuList = __webpack_require__(28536);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/SupportMenu/SupportMenu.views.ts


var Menu = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(components_MenuList/* default */.Z,  true ? {
  target: "ebgg6ms1"
} : 0)("border-radius:0 0 5px 5px;padding:8px 0;background-color:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";border-top:1px solid ", function (_ref2) {
  var borderColor = _ref2.borderColor;
  return borderColor;
}, ";box-shadow:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.shadows[2];
}, ";list-style-type:none;" + ( true ? "" : 0));
var Item = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled(MenuList.Item,  true ? {
  target: "ebgg6ms0"
} : 0)( true ? "" : 0)));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/SupportMenu/SupportMenu.tsx


var SupportMenu_excluded = ["children", "tokens"];

function SupportMenu_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function SupportMenu_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? SupportMenu_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SupportMenu_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseSupportLink = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, SupportMenu_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Menu, SupportMenu_objectSpread(SupportMenu_objectSpread(SupportMenu_objectSpread({
    role: "menu",
    ref: ref
  }, tokens), rest), {}, {
    children: children
  }));
});
var SupportLink = (0,useDesignTokens/* withDesignTokens */.Y)(BaseSupportLink, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100],
      borderColor: theme.palette.twilio.gray[20]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100],
      borderColor: theme.palette.twilio.gray[20]
    };
  },
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100],
      borderColor: theme.palette.brand.darkAcai[200]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100],
      borderColor: theme.palette.brand.darkAcai[200]
    };
  }
});
/* harmony default export */ var SupportMenu = (SupportLink);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/SupportMenu/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/SupportLink/SupportLink.views.ts


function SupportLink_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var SupportLink_views_Item = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "evn4hw50"
} : 0)( true ? {
  name: "11t2w6r",
  styles: "padding:6px 20px"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/SupportLink/SupportLink.tsx


var SupportLink_excluded = ["children", "href", "onClick", "tokens"];

function SupportLink_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function SupportLink_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? SupportLink_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SupportLink_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var SupportLinkBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      href = _ref.href,
      onClick = _ref.onClick,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, SupportLink_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SupportLink_views_Item, SupportLink_objectSpread(SupportLink_objectSpread({
    ref: ref
  }, rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
      size: "small",
      variant: "mono",
      href: href,
      onClick: onClick,
      color: tokens.color,
      children: children
    })
  }));
});
var SupportLink_SupportLink = (0,useDesignTokens/* withDesignTokens */.Y)(SupportLinkBase, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});
/* harmony default export */ var DesktopNavigation_SupportLink_SupportLink = (SupportLink_SupportLink);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/SupportLink/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/index.ts












/***/ }),

/***/ 90806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H2": function() { return /* reexport */ Brand_Brand; },
  "zx": function() { return /* reexport */ Button_Button; },
  "ZP": function() { return /* reexport */ Navbar_Navbar; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/Navbar.views.ts

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1732ui30"
} : 0)("min-height:76px;display:grid;align-items:center;grid-auto-flow:column;justify-content:space-between;padding:20px;background-color:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/Navbar.tsx


var _excluded = ["children", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseNavbar = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, _objectSpread(_objectSpread(_objectSpread({}, tokens), rest), {}, {
    ref: ref,
    children: children
  }));
});
var Navbar = (0,useDesignTokens/* withDesignTokens */.Y)(BaseNavbar, function (_props, theme) {
  return {
    backgroundColor: theme.palette.neutrals.white[100]
  };
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme, _ref2) {
    var _ref2$isMenuOpen = _ref2.isMenuOpen,
        isMenuOpen = _ref2$isMenuOpen === void 0 ? true : _ref2$isMenuOpen;

    if (isMenuOpen) {
      return {
        backgroundColor: theme.palette.neutrals.white[100]
      };
    }

    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Navbar_Navbar = (Navbar);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/Brand/Brand.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Logo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "eiqo9gp0"
} : 0)( true ? {
  name: "xdpgg7",
  styles: "text-decoration:none;display:inline-block;width:150px"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/Brand/Brand.tsx


var Brand_excluded = ["href", "onClick", "children"];

function Brand_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Brand_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Brand_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Brand_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Brand = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _ref$href = _ref.href,
      href = _ref$href === void 0 ? "/" : _ref$href,
      onClick = _ref.onClick,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Brand_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo, Brand_objectSpread(Brand_objectSpread({
    href: href,
    onClick: onClick
  }, rest), {}, {
    ref: ref,
    children: children
  }));
});
/* harmony default export */ var Brand_Brand = (Brand);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/Brand/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/Button/Button.views.ts


function Button_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var MenuButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e1vxtuuw0"
} : 0)( true ? {
  name: "1te1vur",
  styles: "position:relative;cursor:pointer"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/Button/Button.tsx


var Button_excluded = ["onClick", "children"];

function Button_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Button_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Button_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Button_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Button = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var onClick = _ref.onClick,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Button_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuButton, Button_objectSpread(Button_objectSpread({
    onClick: onClick
  }, rest), {}, {
    ref: ref,
    children: children
  }));
});
/* harmony default export */ var Button_Button = (Button);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/Button/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/index.ts




/***/ }),

/***/ 86943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VY": function() { return /* reexport */ Content_Content; },
  "$_": function() { return /* reexport */ Footer_Footer; },
  "X6": function() { return /* reexport */ MobileNavigation_Heading_Heading; },
  "v2": function() { return /* reexport */ MobileNavigation_Menu_Menu; },
  "LY": function() { return /* reexport */ NavItem_NavItem; },
  "$6": function() { return /* reexport */ List_NavList; },
  "wp": function() { return /* reexport */ Navbar/* default */.ZP; },
  "c2": function() { return /* reexport */ MobileNavigation_PrimaryLink_PrimaryLink; },
  "OE": function() { return /* reexport */ MobileNavigation_Tray_Tray; },
  "gt": function() { return /* reexport */ MobileNavigation_UtilityLink_UtilityLink; },
  "ZP": function() { return /* reexport */ MobileNavigation; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/MobileNavigation.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var MobileNav = function MobileNav(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: children
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("nav",  true ? {
  target: "e1gge9cc0"
} : 0)( true ? {
  name: "10syivw",
  styles: "position:sticky;top:0;left:0;z-index:999;width:100%"
} : 0);

/* harmony default export */ var MobileNavigation = (MobileNav);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/index.ts + 8 modules
var Navbar = __webpack_require__(90806);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Menu/Menu.views.ts

var Menu = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1uh00ty0"
} : 0)("position:fixed;top:0;left:0;z-index:999;width:100%;height:100%;background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";display:grid;grid-auto-rows:max-content;width:100%;overflow-y:auto;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Menu/Menu.tsx


var _excluded = ["children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Menu_Menu = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Menu, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
/* harmony default export */ var MobileNavigation_Menu_Menu = (Menu_Menu);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Menu/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Footer/Footer.tsx


function Footer_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Footer = function Footer(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterWrapper, {
    children: children
  });
};

var FooterWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1e474a90"
} : 0)( true ? {
  name: "2uxqqp",
  styles: "display:grid;gap:14px;padding:20px"
} : 0);

/* harmony default export */ var Footer_Footer = (Footer);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Footer/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Content/Content.tsx


function Content_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Content = function Content(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuContent, {
    role: "menu",
    children: children
  });
};

var MenuContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1wud37t0"
} : 0)( true ? {
  name: "hmxbog",
  styles: "display:flex;flex-direction:column;justify-content:space-between;gap:24px"
} : 0);

/* harmony default export */ var Content_Content = (Content);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Content/index.ts

// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(51585);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/ToggleLinkContent/ToggleLinkContent.tsx


var ToggleLinkContent_excluded = ["children", "open"];

function ToggleLinkContent_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ToggleLinkContent_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ToggleLinkContent_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ToggleLinkContent_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var ToggleLinkContent = function ToggleLinkContent(_ref) {
  var children = _ref.children,
      open = _ref.open,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ToggleLinkContent_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", ToggleLinkContent_objectSpread(ToggleLinkContent_objectSpread({}, rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
      initial: false,
      children: open && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.div, {
        initial: "collapsed",
        animate: "open",
        exit: "collapsed",
        variants: {
          open: {
            opacity: 1,
            height: "auto"
          },
          collapsed: {
            opacity: 0,
            height: 0
          }
        },
        transition: {
          duration: 0.2
        },
        children: children
      })
    })
  }));
};

/* harmony default export */ var ToggleLinkContent_ToggleLinkContent = (ToggleLinkContent);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/useToggleLink.ts


var useToggleLink = function useToggleLink(open) {
  var id = (0,react.useId)();
  var contentId = "content-".concat(id);
  var getTriggerProps = (0,react.useCallback)(function (_ref) {
    var href = _ref.href;
    return href ? {
      as: "a",
      href: href
    } : {
      'aria-expanded': open,
      'aria-controls': contentId
    };
  }, [open, contentId]);
  var getContentProps = (0,react.useCallback)(function () {
    return {
      id: contentId,
      'aria-hidden': !open
    };
  }, [contentId, open]);
  return {
    getTriggerProps: getTriggerProps,
    getContentProps: getContentProps
  };
};

/* harmony default export */ var MobileNavigation_useToggleLink = (useToggleLink);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/ToggleIcon/ToggleIcon.tsx



var ToggleIcon = function ToggleIcon(_ref) {
  var open = _ref.open;
  var Icon = open ? Common/* ChevronUpIcon */.g8 : Common/* ChevronDownIcon */.v4;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
    size: "small"
  });
};

/* harmony default export */ var ToggleIcon_ToggleIcon = (ToggleIcon);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/ToggleIcon/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/PrimaryLink/PrimaryLink.views.ts


function PrimaryLink_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var PrimaryLink_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ephepjp1"
} : 0)( true ? {
  name: "1cwloic",
  styles: "width:100%;overflow:hidden"
} : 0);
var PrimaryLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "ephepjp0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.typography.buttonLarge;
}, ";width:100%;padding:14px 20px;display:flex;justify-content:space-between;align-items:center;text-decoration:none;border-bottom:1px solid ", function (_ref2) {
  var borderBottomColor = _ref2.borderBottomColor;
  return borderBottomColor;
}, ";color:", function (_ref3) {
  var color = _ref3.color;
  return color;
}, ";background-color:", function (_ref4) {
  var backgroundColor = _ref4.backgroundColor;
  return backgroundColor;
}, ";&[aria-expanded='true']{color:", function (_ref5) {
  var openColor = _ref5.openColor;
  return openColor;
}, ";background-color:", function (_ref6) {
  var openBackgroundColor = _ref6.openBackgroundColor;
  return openBackgroundColor;
}, ";}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/PrimaryLink/PrimaryLink.tsx


var PrimaryLink_excluded = ["title", "href", "onClick", "open", "children", "tokens"];

function PrimaryLink_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function PrimaryLink_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? PrimaryLink_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PrimaryLink_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}









var BasePrimaryLink = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var title = _ref.title,
      href = _ref.href,
      onClick = _ref.onClick,
      open = _ref.open,
      children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, PrimaryLink_excluded);

  var _useToggleLink = MobileNavigation_useToggleLink(open),
      getTriggerProps = _useToggleLink.getTriggerProps,
      getContentProps = _useToggleLink.getContentProps;

  var isDropdown = typeof open === "boolean";
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PrimaryLink_views_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PrimaryLink, PrimaryLink_objectSpread(PrimaryLink_objectSpread(PrimaryLink_objectSpread(PrimaryLink_objectSpread({
      ref: ref,
      onClick: onClick
    }, getTriggerProps({
      href: href
    })), tokens), rest), {}, {
      children: [title, isDropdown && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleIcon_ToggleIcon, {
        open: open
      })]
    })), isDropdown && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleLinkContent_ToggleLinkContent, PrimaryLink_objectSpread(PrimaryLink_objectSpread({}, getContentProps()), {}, {
      open: open,
      children: children
    }))]
  });
});
var PrimaryLink_PrimaryLink = (0,useDesignTokens/* withDesignTokens */.Y)(BasePrimaryLink, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100],
    backgroundColor: theme.palette.neutrals.white[100],
    borderBottomColor: theme.palette.twilio.gray[20],
    openColor: theme.palette.twilio.blue[60],
    openBackgroundColor: theme.palette.twilio.gray[10]
  };
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
/* harmony default export */ var MobileNavigation_PrimaryLink_PrimaryLink = (PrimaryLink_PrimaryLink);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/PrimaryLink/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityLink/UtilityLink.views.ts


function UtilityLink_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var UtilityLink_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1h1laem2"
} : 0)( true ? {
  name: "1cwloic",
  styles: "width:100%;overflow:hidden"
} : 0);
var padding = {
  x: 20,
  y: 8
};
var Hightlight = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1h1laem1"
} : 0)("position:absolute;bottom:", padding.y / 2, "px;left:", padding.x, "px;right:", padding.x, "px;width:calc(100% - ", padding.x * 2, "px);height:1px;background-color:transparent;" + ( true ? "" : 0));
var UtilityLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e1h1laem0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.typography.buttonSmall.css;
}, ";position:relative;width:100%;padding:", padding.y, "px ", padding.x, "px;display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid transparent;text-decoration:none;color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";background-color:", function (_ref3) {
  var backgroundColor = _ref3.backgroundColor;
  return backgroundColor;
}, ";&[aria-expanded='true']{color:", function (_ref4) {
  var openColor = _ref4.openColor;
  return openColor;
}, ";", Hightlight, "{background-color:", function (_ref5) {
  var openBorderBottomColor = _ref5.openBorderBottomColor;
  return openBorderBottomColor;
}, ";}}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityLink/UtilityLink.tsx


var UtilityLink_excluded = ["title", "open", "onClick", "href", "children", "tokens"];

function UtilityLink_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function UtilityLink_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? UtilityLink_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UtilityLink_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}









var BaseUtilityLink = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var title = _ref.title,
      open = _ref.open,
      onClick = _ref.onClick,
      href = _ref.href,
      children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, UtilityLink_excluded);

  var _useToggleLink = MobileNavigation_useToggleLink(open),
      getTriggerProps = _useToggleLink.getTriggerProps,
      getContentProps = _useToggleLink.getContentProps;

  var isDropdown = typeof open === "boolean";
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UtilityLink_views_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UtilityLink, UtilityLink_objectSpread(UtilityLink_objectSpread(UtilityLink_objectSpread(UtilityLink_objectSpread({
      ref: ref,
      onClick: onClick
    }, getTriggerProps({
      href: href
    })), tokens), rest), {}, {
      children: [title, isDropdown && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleIcon_ToggleIcon, {
        open: open
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hightlight, {})]
    })), isDropdown && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleLinkContent_ToggleLinkContent, UtilityLink_objectSpread(UtilityLink_objectSpread({}, getContentProps()), {}, {
      open: open,
      children: children
    }))]
  });
});
var UtilityLink_UtilityLink = (0,useDesignTokens/* withDesignTokens */.Y)(BaseUtilityLink, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100],
    backgroundColor: theme.palette.neutrals.white[100],
    openColor: theme.palette.twilio.blue[60],
    openBorderBottomColor: theme.palette.twilio.gray[20]
  };
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
/* harmony default export */ var MobileNavigation_UtilityLink_UtilityLink = (UtilityLink_UtilityLink);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityLink/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Tray/Tray.views.ts

var Tray = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ytrjck0"
} : 0)("display:flex;flex-direction:column;padding:12px 0 24px 0;border-bottom:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";background:", function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor;
}, ";width:100%;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Tray/Tray.tsx


function Tray_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Tray_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Tray_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Tray_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var TrayBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tray, Tray_objectSpread(Tray_objectSpread({
    ref: ref
  }, tokens), {}, {
    children: children
  }));
});
var Tray_Tray = (0,useDesignTokens/* withDesignTokens */.Y)(TrayBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20],
      backgroundColor: theme.palette.twilio.gray[10]
    };
  },
  light: function light(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20],
      backgroundColor: theme.palette.twilio.gray[10]
    };
  },
  dark: function dark(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20],
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
/* harmony default export */ var MobileNavigation_Tray_Tray = (Tray_Tray);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Tray/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/List/NavList.views.ts


function NavList_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var List = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e17whbha0"
} : 0)( true ? {
  name: "1oco99j",
  styles: "list-style-type:none;padding:16px 0;display:flex;gap:16px;flex-direction:column"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/List/NavList.tsx


var NavList_excluded = ["children"];

function NavList_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function NavList_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? NavList_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NavList_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var NavList = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, NavList_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, NavList_objectSpread(NavList_objectSpread({
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
/* harmony default export */ var List_NavList = (NavList);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/List/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Heading/Heading.views.ts


function Heading_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e8e5i5x2"
} : 0)("margin:0;color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";" + ( true ? "" : 0));
var Heading_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e8e5i5x1"
} : 0)( true ? {
  name: "ybax9c",
  styles: "padding:32px 36px 0 36px"
} : 0);
var Inner = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e8e5i5x0"
} : 0)( true ? {
  name: "1i1kavw",
  styles: "display:flex;margin-bottom:6px;align-items:center;gap:12px"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Heading/Heading.tsx






var HeadingBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var Icon = _ref.icon,
      children = _ref.children,
      tokens = _ref.tokens;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Heading_views_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Inner, {
      children: [Icon && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
        variant: "h5",
        ref: ref,
        color: tokens.color,
        children: children
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})]
  });
});
var Heading_Heading = (0,useDesignTokens/* withDesignTokens */.Y)(HeadingBase, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
/* harmony default export */ var MobileNavigation_Heading_Heading = (Heading_Heading);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Heading/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/NavItem/NavItem.views.ts


function NavItem_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var NavItem_views_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "etkvny02"
} : 0)( true ? {
  name: "sau5os",
  styles: "gap:4px;padding:0 36px;display:flex;flex-direction:column;text-decoration:none"
} : 0);
var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "etkvny01"
} : 0)("margin:0;color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";" + ( true ? "" : 0));
var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "etkvny00"
} : 0)("margin:2px 0 0;line-height:1.5;color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/NavItem/NavItem.tsx


var NavItem_excluded = ["href", "title", "description", "role", "onClick", "tokens"];

function NavItem_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function NavItem_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? NavItem_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NavItem_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var NavItemBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var href = _ref.href,
      title = _ref.title,
      description = _ref.description,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? "menuitem" : _ref$role,
      onClick = _ref.onClick,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, NavItem_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavItem_views_Wrapper, NavItem_objectSpread(NavItem_objectSpread({
    role: role,
    href: href,
    onClick: onClick
  }, rest), {}, {
    ref: ref,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, NavItem_objectSpread(NavItem_objectSpread({
      variant: "buttonSmall"
    }, tokens.title), {}, {
      children: title
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, NavItem_objectSpread(NavItem_objectSpread({
      variant: "textRegularSmall"
    }, tokens.description), {}, {
      children: description
    }))]
  }));
});
var NavItem = (0,useDesignTokens/* withDesignTokens */.Y)(NavItemBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      title: {
        color: theme.palette.twilio.gray[100]
      },
      description: {
        color: theme.palette.twilio.gray[60]
      }
    };
  },
  light: function light(theme) {
    return {
      title: {
        color: theme.palette.brand.darkAcai[900]
      },
      description: {
        color: theme.palette.brand.darkAcai[400]
      }
    };
  },
  dark: function dark(theme) {
    return {
      title: {
        color: theme.palette.brand.darkAcai[900]
      },
      description: {
        color: theme.palette.brand.darkAcai[400]
      }
    };
  }
});
/* harmony default export */ var NavItem_NavItem = (NavItem);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/NavItem/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/index.ts













/***/ }),

/***/ 98439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* reexport safe */ _withDesignTokens__WEBPACK_IMPORTED_MODULE_1__.Z; }
/* harmony export */ });
/* harmony import */ var _useDesignTokens__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88992);
/* harmony import */ var _withDesignTokens__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72300);



/***/ }),

/***/ 88992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98537);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28543);
/* harmony import */ var _foundations_AppearanceContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9381);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var useDesignTokens = function useDesignTokens(props, defaultTokens, definitions) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref$defaultAppearanc = _ref.defaultAppearance,
      defaultAppearance = _ref$defaultAppearanc === void 0 ? "light" : _ref$defaultAppearanc;

  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.u)();
  var appearance = (0,_foundations_AppearanceContext__WEBPACK_IMPORTED_MODULE_2__/* .useAppearance */ .M)(props.appearance, {
    defaultAppearance: defaultAppearance
  });
  var definition = definitions[appearance];
  if (!definition) throw new Error("No definition for appearance \"".concat(appearance, "\""));
  var definitionTokens = definition(theme, props);

  if (typeof definitionTokens !== "object") {
    throw new Error("Definition for appearance \"".concat(appearance, "\" did not return an object"));
  }

  return lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(_objectSpread({}, defaultTokens(props, theme)), definitionTokens, props.tokens);
};

/* harmony default export */ __webpack_exports__["Z"] = (useDesignTokens);

/***/ }),

/***/ 72300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _useDesignTokens__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88992);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52903);


var _excluded = ["tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var withDesignTokens = function withDesignTokens(Component, defaultTokens, definitionMap) {
  var WithDesignTokens = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (props, ref) {
    var tokens = (0,_useDesignTokens__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, defaultTokens, definitionMap); // eslint-disable-next-line @typescript-eslint/no-unused-vars

    var _tokens = props.tokens,
        rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded);

    var UntypedComponent = Component;
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(UntypedComponent, _objectSpread(_objectSpread({
      ref: ref
    }, rest), {}, {
      tokens: tokens
    }));
  });
  WithDesignTokens.displayName = "WithDesignTokens(".concat(Component.displayName, ")");
  return WithDesignTokens;
};

/* harmony default export */ __webpack_exports__["Z"] = (withDesignTokens);

/***/ }),

/***/ 6372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/@segment/snippet/lib/index.js
var lib = __webpack_require__(70490);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/tracking/index.ts + 1 modules
var tracking = __webpack_require__(55156);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js + 2 modules
var emotion_serialize_browser_esm = __webpack_require__(40653);
// EXTERNAL MODULE: ../../node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
var emotion_sheet_browser_esm = __webpack_require__(32281);
// EXTERNAL MODULE: ../../node_modules/stylis/src/Serializer.js
var Serializer = __webpack_require__(59452);
// EXTERNAL MODULE: ../../node_modules/stylis/src/Parser.js + 1 modules
var Parser = __webpack_require__(41561);
// EXTERNAL MODULE: ../../node_modules/stylis/src/Middleware.js
var Middleware = __webpack_require__(30312);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/next-shared/layout/Layout.views.tsx






var LayoutGlobalStyles = function LayoutGlobalStyles(_ref) {
  var backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Global, {
    styles: "\n      body {\n        background-color: ".concat(backgroundColor, ";\n      }\n    ")
  });
}; // https://github.com/emotion-js/emotion/issues/2131

var Global = function Global(_ref2) {
  var styles = _ref2.styles;
  (0,react.useEffect)(function () {
    var removeStyles = injectGlobal(styles);
    return function () {
      return removeStyles();
    };
  }, [styles]);
  return null;
};

var injectGlobal = function injectGlobal() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var _serializeStyles = emotion_serialize_browser_esm/* serializeStyles.apply */.O.apply(void 0, (0,toConsumableArray/* default */.Z)(args)),
      name = _serializeStyles.name,
      styles = _serializeStyles.styles;

  var sheet = new emotion_sheet_browser_esm/* StyleSheet */.m({
    key: "global-".concat(name),
    container: document.body
  });

  var stylis = function stylis(styles) {
    return (0,Serializer/* serialize */.q)((0,Parser/* compile */.MY)(styles), (0,Middleware/* middleware */.qR)([Serializer/* stringify */.P, (0,Middleware/* rulesheet */.cD)(function (rule) {
      sheet.insert(rule);
    })]));
  };

  stylis(styles);
  return function () {
    return sheet.flush();
  };
};
// EXTERNAL MODULE: ../../libs/next-shared/layout/assets/apple-icon-57x57.png?url
var apple_icon_57x57url = __webpack_require__(60602);
var apple_icon_57x57url_default = /*#__PURE__*/__webpack_require__.n(apple_icon_57x57url);
// EXTERNAL MODULE: ../../libs/next-shared/layout/assets/apple-icon-60x60.png?url
var apple_icon_60x60url = __webpack_require__(95800);
var apple_icon_60x60url_default = /*#__PURE__*/__webpack_require__.n(apple_icon_60x60url);
// EXTERNAL MODULE: ../../libs/next-shared/layout/assets/apple-icon-72x72.png?url
var apple_icon_72x72url = __webpack_require__(43195);
var apple_icon_72x72url_default = /*#__PURE__*/__webpack_require__.n(apple_icon_72x72url);
// EXTERNAL MODULE: ../../libs/next-shared/layout/assets/apple-icon-76x76.png?url
var apple_icon_76x76url = __webpack_require__(63239);
var apple_icon_76x76url_default = /*#__PURE__*/__webpack_require__.n(apple_icon_76x76url);
// EXTERNAL MODULE: ../../libs/next-shared/layout/assets/apple-icon-114x114.png?url
var apple_icon_114x114url = __webpack_require__(28386);
var apple_icon_114x114url_default = /*#__PURE__*/__webpack_require__.n(apple_icon_114x114url);
// EXTERNAL MODULE: ../../libs/next-shared/layout/assets/apple-icon-120x120.png?url
var apple_icon_120x120url = __webpack_require__(59625);
var apple_icon_120x120url_default = /*#__PURE__*/__webpack_require__.n(apple_icon_120x120url);
// EXTERNAL MODULE: ../../libs/next-shared/layout/assets/apple-icon-144x144.png?url
var apple_icon_144x144url = __webpack_require__(69497);
var apple_icon_144x144url_default = /*#__PURE__*/__webpack_require__.n(apple_icon_144x144url);
// EXTERNAL MODULE: ../../libs/next-shared/layout/assets/apple-icon-152x152.png?url
var apple_icon_152x152url = __webpack_require__(20740);
var apple_icon_152x152url_default = /*#__PURE__*/__webpack_require__.n(apple_icon_152x152url);
// EXTERNAL MODULE: ../../libs/next-shared/layout/assets/android-icon-192x192.png?url
var android_icon_192x192url = __webpack_require__(46134);
var android_icon_192x192url_default = /*#__PURE__*/__webpack_require__.n(android_icon_192x192url);
// EXTERNAL MODULE: ../../libs/next-shared/layout/assets/favicon-32x32.png?url
var favicon_32x32url = __webpack_require__(78643);
var favicon_32x32url_default = /*#__PURE__*/__webpack_require__.n(favicon_32x32url);
// EXTERNAL MODULE: ../../libs/next-shared/layout/assets/favicon-96x96.png?url
var favicon_96x96url = __webpack_require__(27468);
var favicon_96x96url_default = /*#__PURE__*/__webpack_require__.n(favicon_96x96url);
// EXTERNAL MODULE: ../../libs/next-shared/layout/assets/favicon-16x16.png?url
var favicon_16x16url = __webpack_require__(56490);
var favicon_16x16url_default = /*#__PURE__*/__webpack_require__.n(favicon_16x16url);
// EXTERNAL MODULE: ../../libs/next-shared/layout/assets/ms-icon-144x144.png?url
var ms_icon_144x144url = __webpack_require__(71899);
var ms_icon_144x144url_default = /*#__PURE__*/__webpack_require__.n(ms_icon_144x144url);
// EXTERNAL MODULE: ../../libs/next-shared/layout/assets/SegmentOgImage.jpg
var SegmentOgImage = __webpack_require__(99653);
var SegmentOgImage_default = /*#__PURE__*/__webpack_require__.n(SegmentOgImage);
;// CONCATENATED MODULE: ../../libs/next-shared/layout/Layout.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}










 // We want to import favicons via file-loader to make sure webpack doesn't inline them



















var usePageLoadEventTracking = function usePageLoadEventTracking(pageTitle) {
  var _useRouter = (0,router.useRouter)(),
      events = _useRouter.events;

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      baseUrl = _usePageConfig.baseUrl;

  (0,react.useEffect)(function () {
    var handleRouteChange = function handleRouteChange(urlPath) {
      var _window$analytics;

      (_window$analytics = window.analytics) === null || _window$analytics === void 0 ? void 0 : _window$analytics.page(pageTitle, {
        path: urlPath,
        url: "".concat(baseUrl).concat(urlPath)
      });
    };

    events.on("routeChangeComplete", handleRouteChange); // If the component is unmounted, unsubscribe from the event

    return function () {
      events.off("routeChangeComplete", handleRouteChange);
    };
  }, [events, pageTitle, baseUrl]);
};

var useTrackReferer = function useTrackReferer() {
  var _useRouter2 = (0,router.useRouter)(),
      query = _useRouter2.query;

  var _useTracking = (0,tracking/* useTracking */.r)(),
      track = _useTracking.track;

  (0,react.useEffect)(function () {
    if (query !== null && query !== void 0 && query.email) {
      var _document$referrer, _document;

      track("Debug Email Parameter in URL", {
        referer: (_document$referrer = (_document = document) === null || _document === void 0 ? void 0 : _document.referrer) !== null && _document$referrer !== void 0 ? _document$referrer : ""
      }, false, "client");
    }
  }, [query, track]);
};

var ASSETS_URL = "images.ctfassets.net";

var getOgUrl = function getOgUrl(baseUrl, path) {
  var host = baseUrl || "http://localhost:3000";
  var pathWithoutQueryString = path.split("?")[0];
  var pathWithTrailingSlash = pathWithoutQueryString.endsWith("/") ? pathWithoutQueryString : "".concat(pathWithoutQueryString, "/");
  return "".concat(host).concat(pathWithTrailingSlash);
};

var BaseLayout = function BaseLayout(_ref) {
  var _process$env$GOOGLE_S;

  var pageTitle = _ref.pageTitle,
      _ref$pageDescription = _ref.pageDescription,
      pageDescription = _ref$pageDescription === void 0 ? "" : _ref$pageDescription,
      _ref$pageOG = _ref.pageOG,
      pageOG = _ref$pageOG === void 0 ? (SegmentOgImage_default()) : _ref$pageOG,
      pageRobotsDirective = _ref.pageRobotsDirective,
      canonicalUrl = _ref.canonicalUrl,
      themeColor = _ref.themeColor,
      children = _ref.children,
      tokens = _ref.tokens;
  usePageLoadEventTracking(pageTitle);
  useTrackReferer();
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var baseUrl = pageConfig.baseUrl;
  var ogImageUrl = pageOG !== null && pageOG !== void 0 && pageOG.includes(ASSETS_URL) ? pageOG : "".concat(baseUrl).concat(pageOG);
  var googleVerificationIds = (_process$env$GOOGLE_S = "zf8bIVD8wj8cL5jl7qswcD_T6GKnwG6O0vs4vOPlwDA,Zhlnzjin0lNtmHPq0AQpFuZ3x-hpIL0fbdzd5stzkkU,u-46MjmrvtDWUIsqerNGAKn5pdQviygBP-YBrYUwa7I") !== null && _process$env$GOOGLE_S !== void 0 ? _process$env$GOOGLE_S : "";

  var _useRouter3 = (0,router.useRouter)(),
      asPath = _useRouter3.asPath;

  var ogUrl = getOgUrl(baseUrl, asPath);
  (0,react.useEffect)(function () {
    var untypedWindow = window; // Ensures the optimizely object is defined globally

    untypedWindow.optimizely = untypedWindow.optimizely || []; // Set the waitForOriginSync API call
    // place your own domains in the canonicalOrigins array

    untypedWindow.optimizely.push({
      type: "waitForOriginSync",
      canonicalOrigins: ["segment.com", "cdpweek.com", "preview.segment.build"]
    });
  }, []);
  var analyticsJsMinified = (0,react.useMemo)(function () {
    return  true ? lib.min({
      apiKey: "zaySL4FGIiLsxt3I7omU5uLxXqxaBMPh",
      host: "ajs.cd.segment.com",
      load: false,
      page: {
        name: pageTitle
      }
    }) : 0;
  }, [pageTitle]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
        children: pageTitle
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:title",
        content: pageTitle
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:site_name",
        content: "Segment"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:url",
        content: ogUrl
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:type",
        content: "website"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        name: "robots",
        content: pageRobotsDirective
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        name: "twitter:title",
        content: pageTitle
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        name: "twitter:site",
        content: "@segment"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        name: "twitter:card",
        content: "summary_large_image"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:image",
        content: ogImageUrl
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        name: "twitter:image",
        content: ogImageUrl
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        name: "description",
        content: pageDescription
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        name: "twitter:description",
        content: pageDescription
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        property: "og:description",
        content: pageDescription
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
        rel: "apple-touch-icon",
        sizes: "57x57",
        href: (apple_icon_57x57url_default())
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
        rel: "apple-touch-icon",
        sizes: "60x60",
        href: (apple_icon_60x60url_default())
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
        rel: "apple-touch-icon",
        sizes: "72x72",
        href: (apple_icon_72x72url_default())
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
        rel: "apple-touch-icon",
        sizes: "76x76",
        href: (apple_icon_76x76url_default())
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
        rel: "apple-touch-icon",
        sizes: "114x114",
        href: (apple_icon_114x114url_default())
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
        rel: "apple-touch-icon",
        sizes: "120x120",
        href: (apple_icon_120x120url_default())
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
        rel: "apple-touch-icon",
        sizes: "144x144",
        href: (apple_icon_144x144url_default())
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
        rel: "apple-touch-icon",
        sizes: "152x152",
        href: (apple_icon_152x152url_default())
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
        rel: "icon",
        type: "image/png",
        sizes: "192x192",
        href: (android_icon_192x192url_default())
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
        rel: "icon",
        type: "image/png",
        sizes: "32x32",
        href: (favicon_32x32url_default())
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
        rel: "icon",
        type: "image/png",
        sizes: "96x96",
        href: (favicon_96x96url_default())
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
        rel: "icon",
        type: "image/png",
        sizes: "16x16",
        href: (favicon_16x16url_default())
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        name: "msapplication-TileImage",
        content: (ms_icon_144x144url_default())
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
        rel: "manifest",
        href: (0,getAbsoluteUrl/* default */.Z)("/manifest.json", pageConfig)
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
        rel: "canonical",
        href: canonicalUrl !== null && canonicalUrl !== void 0 ? canonicalUrl : "".concat(baseUrl).concat(asPath)
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        name: "msapplication-TileColor",
        content: theme.palette.brand.segmentGreen[100]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        name: "theme-color",
        content: themeColor
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        name: "facebook-domain-verification",
        content: "keycc8nnnqsmhe8y94sno335btxjog"
      }), googleVerificationIds.split(",").map(function (id, idx) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
          name: "google-site-verification",
          content: id
        }, idx);
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
        async: true,
        dangerouslySetInnerHTML: {
          __html: analyticsJsMinified
        }
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutGlobalStyles, _objectSpread({}, tokens)), children]
  });
};

/* harmony default export */ var Layout = ((0,useDesignTokens/* withDesignTokens */.Y)(BaseLayout, function () {
  return {};
}, {
  light: function light(theme, props) {
    return {
      backgroundColor: props.bodyBackground || theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme, props) {
    return {
      backgroundColor: props.bodyBackground || theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme, props) {
    return {
      backgroundColor: props.bodyBackground || theme.palette.neutrals.white[100]
    };
  },
  twilioDark: function twilioDark(theme, props) {
    return {
      backgroundColor: props.bodyBackground || theme.palette.twilio.gray[100]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme, props) {
    return {
      backgroundColor: props.bodyBackground || theme.palette.cdpWeek2023.gray[100]
    };
  }
}));

/***/ }),

/***/ 43848:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Returns an absolute URL for a given path.
 * @param path - The path to convert to an absolute URL.
 * @param options - The options to use when converting the path to an absolute URL.
 * @param options.baseUrl - The base URL to use for the absolute URL.
 * @param options.basePath - The path prefix to use for the absolute URL.
 * @returns The absolute URL.
 * @example
 * getAbsoluteUrl('/blog', { baseUrl: 'https://segment.com', basePath: '/matcha' }) // => 'https://segment.com/matcha/blog'
 */
var getAbsoluteUrl = function getAbsoluteUrl(path, _ref) {
  var baseUrl = _ref.baseUrl,
      basePath = _ref.basePath;

  if (!path.startsWith("/")) {
    return path;
  }

  return "".concat(baseUrl).concat(basePath).concat(path);
};

/* harmony default export */ __webpack_exports__["Z"] = (getAbsoluteUrl);

/***/ }),

/***/ 93026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _useEventCallback__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _useEventCallback__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56386);


/***/ }),

/***/ 56386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useEventCallback_useEventCallback; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useIsomorphicLayout/useIsomorphicLayout.ts

/**
 * A hook to use either useEffect or useLayoutEffect depending on the environment
 * @param effect - The function to be called
 * @param deps - The dependencies for the function
 */

var useIsomorphicLayout = function useIsomorphicLayout(effect, deps) {
  var hook =  false ? 0 : react.useLayoutEffect;
  hook(effect, deps);
};

/* harmony default export */ var useIsomorphicLayout_useIsomorphicLayout = (useIsomorphicLayout);
;// CONCATENATED MODULE: ../../libs/utils/useIsomorphicLayout/index.ts

;// CONCATENATED MODULE: ../../libs/utils/useEventCallback/useEventCallback.ts



/**
 * A hook to create a memoized callback that will always have the latest version of the callback function
 * @param fn - The function to memoize
 * @param dependencies - The dependencies of the function
 * @returns The memoized callback
 */

var useEventCallback = function useEventCallback(fn, dependencies) {
  var ref = (0,react.useRef)();
  useIsomorphicLayout_useIsomorphicLayout(function () {
    ref.current = fn;
  }, [fn].concat((0,toConsumableArray/* default */.Z)(dependencies)));
  return (0,react.useCallback)(function () {
    if (ref.current) {
      return ref.current.apply(ref, arguments);
    }
  }, []);
};

/* harmony default export */ var useEventCallback_useEventCallback = (useEventCallback);

/***/ }),

/***/ 61093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useMatchMedia_useMatchMedia; }
});

// EXTERNAL MODULE: ../../node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(45455);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useMatchMedia/useMatchMedia.ts


/**
 * Window.matchMedia browser API closed in React hook. It triggers component
 * renders on media query change event
 *
 * @param mediaQuery - media query string without '@media' prefix eg. (min-width: 1000px)
 * @param initialValue - needed for SSR
 */

var useMatchMedia = function useMatchMedia(mediaQuery, initialValue) {
  var _useState = (0,react.useState)(mediaQuery ? initialValue : false),
      isMatching = _useState[0],
      setIsMatching = _useState[1];

  (0,react.useEffect)(function () {
    if (!isEmpty_default()(mediaQuery)) {
      var watcher = window.matchMedia(mediaQuery);
      setIsMatching(watcher.matches);

      var listener = function listener(matches) {
        if (mediaQuery && mediaQuery.length > 0) {
          setIsMatching(matches.matches);
        } else {
          setIsMatching(false);
        }
      };

      if (watcher.addEventListener) {
        watcher.addEventListener("change", listener);
      } else {
        watcher.addListener(listener);
      }

      return function () {
        if (watcher.removeEventListener) {
          return watcher.removeEventListener("change", listener);
        }

        return watcher.removeListener(listener);
      };
    }
  }, [mediaQuery]);
  return isMatching;
};

/* harmony default export */ var useMatchMedia_useMatchMedia = (useMatchMedia);
;// CONCATENATED MODULE: ../../libs/utils/useMatchMedia/index.ts


/***/ }),

/***/ 99653:
/***/ (function(module) {

module.exports = "/_next/static/images/SegmentOgImage-50313581c7e6a8554429b3a63c98a809.jpg";

/***/ })

}]);